/** Travel 前端文案；error key 路徑與後端 ErrorResponse.key 對齊（travel.grouptrip.* / travel.trade.*）。 */
export const travelZhTW = {
  discover: {
    title: '探索',
    subtitle: '瀏覽公開的旅遊故事與行程，再決定要追蹤或收藏。',
    compose: '發佈貼文',
    tabsLabel: '探索分頁',
    railLabel: '探索資訊',
    railTitle: '故事與行程怎麼連在一起',
    railHint: '貼文常連結公開行程；行程頁可看路線與安排，再回探索繼續逛。',
    firstUse: {
      guestLead: '第一次來？可以這樣開始：',
      guestPost: '在「推薦」閱讀公開旅遊故事',
      guestJourney: '在「行程」或右側入口查看公開行程',
      guestLogin: '按讚、收藏、追蹤與發佈需先登入',
    },
    tabs: {
      forYou: '推薦',
      journeys: '行程',
      social: '貼文',
    },
    kinds: {
      ALL: '全部',
      MOOD: '心情',
      JOURNEY: '旅程',
      JOURNEY_INVITATION: '旅程邀請',
      PLACE: '地點',
      FOOD: '美食',
    },
    posts: {
      viewLabel: '貼文檢視',
      list: '清單',
      map: '地圖',
      location: '地點',
      kind: '類型',
      allLocations: '全部地點',
      following: '追蹤中',
      followingHint: '只看你追蹤的人',
      showOnMap: '在地圖查看',
      filtersLabel: '貼文篩選',
      publicJourney: '公開行程',
      openPublishedJourney: '查看已發布的行程與地圖',
      journeyUnavailable: '旅程目前無法顯示',
    },
    locationSelector: {
      root: '全部地點',
      selectedPrefix: '已選：',
      back: '返回',
      clear: '清除地點',
      loading: '載入地點中…',
      loadFailed: '無法載入地點。',
      use: '使用此地點',
      selected: '已選取',
      openChildren: '查看下層',
      empty: '此層級沒有地點。',
    },
    loading: '載入中…',
    end: '已顯示全部內容。',
    notInterested: '不感興趣',
    mute: '靜音創作者',
    hideContent: '隱藏這則內容',
    days: '天',
    viewJourney: '查看行程',
    contentType: {
      journey: '公開行程',
      socialPost: '旅遊故事',
    },
    empty: {
      title: '暫無內容',
      hint: '稍後再回來看看個人化推薦。',
      guestHint: '目前還沒有可推薦的內容。你可以先逛公開行程，或登入後再回來看看。',
    },
    error: {
      title: '無法載入',
      loadFailed: '無法載入行程。',
      postsLoadFailed: '無法載入貼文。',
      actionFailed: '操作失敗，請重試。',
    },
    journeys: {
      emptyTitle: '找不到符合的行程',
      emptyHint: '試著調整篩選條件。',
      emptyWithQuery: '找不到符合「{q}」的行程，可換關鍵字或清除搜尋。',
    },
    filters: {
      label: '行程篩選',
      location: '地點',
      allLocations: '全部地點',
      clearLocation: '清除地點',
      selectedLocation: '已選地點',
      budgetMin: '最低預算',
      budgetMax: '最高預算',
      currency: '幣別',
      minDays: '最少天數',
      maxDays: '最多天數',
      sort: '排序',
      apply: '套用',
      reset: '重設',
    },
    search: {
      label: '搜尋行程',
      placeholder: '東京、鎌倉、Tokyo…',
      submit: '搜尋',
      clear: '清除',
      context: '正在搜尋「{q}」',
    },
    suggestions: {
      loading: '建議載入中…',
      empty: '沒有建議，可按 Enter 搜尋。',
      error: '建議暫時無法使用，仍可按 Enter 搜尋。',
      type: {
        geo: '地點',
        journey: '行程',
      },
    },
    sort: {
      latest: '最新',
      hot: '熱門',
    },
  },
  nav: {
    brand: 'Formosa Travel',
    explore: '探索',
    journeys: '行程',
    groupTripDiscover: '揪團',
    me: '我的',
    primary: '主要導覽',
    primaryMobile: '行動主要導覽',
    notificationCenter: '通知中心',
    saved: '我的收藏',
    messages: '訊息',
    myJourneys: '我的行程',
    findGroupTrips: '找揪團',
    groupTrips: '我的揪團',
    earnings: '收益與交易',
    invitations: '旅程邀請',
    notices: '揪團通知',
    notifications: '通知',
    publicGroupTrips: '公開揪團',
    more: '更多',
    profile: '我的創作者頁面',
    signIn: '登入',
    signOut: '登出',
    register: '註冊',
    /** Guest Header 單一入口；點擊後進入 Login，可再切換 Register。 */
    signInRegister: '登入 / 註冊',
    checkingSession: '正在確認登入狀態…',
    member: '會員',
    language: '語言',
  },
  auth: {
    googleContinue: '使用 Google 繼續',
    googleConnecting: '連線中…',
    googleUnavailable: '目前無法使用 Google 繼續（缺少設定）。',
  },
  places: {
    searchLabel: '搜尋地點',
    searchPlaceholder: '輸入地點名稱',
    resolving: '正在確認地點',
    searching: '搜尋中…',
    loadingProvider: '正在載入地點搜尋…',
    candidatesLabel: '地點候選',
  },
  direct: {
    errors: {
      unavailable: '目前無法傳訊息給這位旅人。',
      privacyDenied: '對方目前不接受新的私訊。',
      chatDisabled: '目前暫時無法建立新的對話，請稍後再試。',
      accountCannotUse: '目前的帳號無法使用私訊。',
      peerNotFound: '找不到這位旅人。',
      authExpired: '登入已過期，請重新登入後再試。',
      network: '網路暫時無法連線，請稍後再試。',
      startFailed: '無法開始對話，請稍後再試。',
    },
  },
  discoverGuest: {
    title: '登入後繼續探索',
    body: '按讚、收藏、留言、追蹤與地圖探索需要登入。你仍可先在「推薦」閱讀公開故事。',
    followingTitle: '登入後查看追蹤動態',
    followingBody: '「追蹤中」會顯示你追蹤的旅人最新貼文。登入後會回到這個分頁。',
    mapTitle: '登入後探索旅遊地圖',
    mapBody: '地圖探索需要登入。登入後會回到此分頁；你也可以先回「推薦」繼續瀏覽公開內容。',
    socialTitle: '登入後瀏覽貼文探索',
    socialBody: '此貼文探索檢視需要登入。你仍可先在「推薦」閱讀公開故事與公開行程。',
    cta: '登入以繼續',
    browseForYou: '先回推薦瀏覽',
    footnote: '登入後會回到你剛才想去的頁面。',
    engagementNotice: '登入後即可按讚、收藏或留言，並回到目前頁面。',
  },
  journeyWorkspace: {
    overviewHint: '設定這趟去哪、哪幾天，以及行程的基本資訊。',
    planningHint: '安排每天要做什麼、時間與地點。',
  },
  journeyCost: {
    disclaimer: '此功能僅協助記帳與分攤，不代表平台已代為付款。',
    actions: {
      refresh: '重新整理',
      cancel: '取消',
      confirm: '確認',
      saving: '儲存中…',
      reloadBudget: '重新載入最新預算',
    },
    budget: {
      total: '總預算',
      spent: '已記支出',
      remaining: '剩餘額度',
      currency: '幣別',
      allocated: '已分配',
      unallocated: '未分配',
      baseCurrencyHint: '基準幣別 · 單一行程',
      allocatedHint: '分類額度合計',
      unallocatedHint: '總預算 − 已分配',
      actualOnExpenses: '實際已記支出請至「支出」查看；本頁僅顯示預算分配。',
      openExpenses: '開啟支出',
      edit: '編輯預算',
      create: '建立預算',
      save: '儲存預算',
      categoryLegend: '類別分配',
      allocatedPreview: '已分配預覽',
      unallocatedPreview: '未分配預覽',
      openFailed: '無法開啟預算',
      validation: '請檢查預算數值。',
      forbidden: '你沒有權限變更此預算。',
      lifecycle: '目前行程狀態無法變更預算。',
      alreadyExists: '預算已存在，請重新載入後編輯。',
      readonlyRole: '唯讀：僅擁有者或協調者可變更預算。',
      readonlyLifecycle: '唯讀：目前行程狀態無法變更預算。',
      confirmCreateTitle: '確認建立預算？',
      confirmReplaceTitle: '確認更新預算？',
      confirmCreateBody: '將以你輸入的數值設定旅行預算。',
      confirmReplaceBody: '這會完整取代預算與類別分配。',
      emptyTitle: '尚未設定旅行預算',
      setup: '設定預算',
      conflict: '預算已被其他操作更新。請重新載入最新預算。',
      currencyMismatch: '預算幣別需與行程幣別一致',
      validationErrors: {
        currencyRequired: '請選擇幣別（ISO 4217）。',
        baselineInvalid: '總預算必須是有效且不為負數的金額。',
        baselineNegative: '總預算不可為負數。',
        categoriesRequired: '至少需要一個類別分配。',
        categoryUnknown: '未知的類別：{category}',
        categoryAmountInvalid: '{category}的金額無效。',
        categoryAmountNegative: '{category}的金額不可為負數。',
        allocationExceedsTotal: '類別分配合計不可超過總預算。',
      },
    },
    categories: {
      ACCOMMODATION: '住宿',
      TRANSPORT: '交通',
      FOOD: '餐飲',
      TICKET: '票券',
      SHOPPING: '購物',
      INSURANCE: '保險',
      COMMUNICATION: '通訊',
      OTHER: '其他',
    },
    expense: {
      statusAll: '全部',
      statusActive: '進行中',
      statusVoided: '已作廢',
      splitPreview: '分攤預覽（最終以伺服器結果為準）',
    },
    split: {
      settlementTitle: '結算建議（僅供參考）',
      settlementCopy: '以下建議協助成員自行結算，平台不會代收、代付或標記結算狀態。',
      confirmNotPayment: '請確認你了解：這不是付款流程。',
      statusCurrent: '最新',
      statusOutdated: '已過期',
      statusEmpty: '尚未計算',
    },
  },
  common: {
    travel: 'Travel',
    loading: '載入中…',
    retry: '重試',
    loadMore: '載入更多',
    loadFailed: '載入失敗',
    actionFailed: '操作失敗，請稍後再試。',
    empty: '目前沒有資料',
    back: '返回',
    cancel: '取消',
    read: '已讀',
    host: '主揪',
    participants: '旅伴',
    apiError: {
      network: {
        title: '網路連線失敗',
        description: '請確認連線後再試一次。',
      },
      unauthorized: {
        title: '登入狀態失效',
        description: '請重新登入後再繼續。',
      },
      forbidden: {
        title: '沒有權限',
        description: '你目前無法執行此操作。',
      },
      notFound: {
        title: '找不到內容',
        description: '指定的內容不存在或已移除。',
      },
      validation: {
        title: '資料有誤',
        description: '請檢查輸入內容後再試。',
      },
      conflict: {
        title: '資料已更新',
        description: '請重新整理後再試一次。',
      },
      rateLimited: {
        title: '操作過於頻繁',
        description: '請稍後再試。',
      },
      unavailable: {
        title: '服務暫時無法使用',
        description: '請稍後再試一次。',
      },
      server: {
        title: '服務暫時發生問題',
        description: '請稍後再試一次。',
      },
      domain: {
        title: '無法完成操作',
        description: '請稍後再試。',
      },
      unknown: {
        title: '發生錯誤',
        description: '請稍後再試一次。',
      },
    },
  },
  groupTripNotice: {
    title: '揪團通知',
    types: {
      APPLICATION_RECEIVED: '新的參加申請',
      APPLICATION_APPROVED: '參加成功',
      APPLICATION_REJECTED: '申請結果',
      APPLICATION_WITHDRAWN: '申請已撤回',
      PARTICIPANT_REMOVED: '參與資格變更',
      PARTICIPANT_LEFT: '成員退出',
      GROUP_TRIP_CANCELLED: '揪團已取消',
      GROUP_TRIP_STARTING_SOON: '即將出發',
      UNKNOWN: '揪團通知',
    },
    messages: {
      APPLICATION_RECEIVED: '你的揪團收到新的參加申請',
      APPLICATION_APPROVED: '你已成功加入這個揪團',
      APPLICATION_REJECTED: '你的參加申請未通過',
      APPLICATION_WITHDRAWN: '一筆參加申請已撤回',
      PARTICIPANT_REMOVED: '你已被移出這個揪團',
      PARTICIPANT_LEFT: '有成員退出了這個揪團',
      GROUP_TRIP_CANCELLED: '這個揪團已取消',
      GROUP_TRIP_STARTING_SOON: '這個揪團即將出發，記得確認集合與行程資訊',
    },
    unread: '未讀',
    markRead: '標為已讀',
    markAll: '全部標為已讀',
    markAllDone: '已全部標為已讀',
    empty: '目前沒有揪團通知',
    emptyDescription: '有新的申請或行程異動時，會顯示在這裡。',
    lead: '追蹤揪團申請與行程異動。',
    error: '無法載入揪團通知',
    actionFailed: '操作失敗，請重試',
    loadMore: '載入更多通知',
    openTrip: '查看揪團',
  },
  notificationCenter: {
    relatedAria: '其他通知入口',
    relatedLabel: '其他入口',
    announcements: '公告',
    siteMail: '站內信',
  },
  socialNotification: {
    title: '通知',
    bell: '通知',
    someone: '有人',
    unread: '未讀',
    markRead: '標為已讀',
    markAll: '全部標為已讀',
    markAllDone: '已全部標為已讀',
    empty: '目前沒有通知',
    emptyDescription: '有人追蹤、按讚或留言時，會顯示在這裡。',
    lead: '查看社群互動與最新動態。',
    error: '無法載入通知',
    actionFailed: '操作失敗，請重試',
    loadMore: '載入更多通知',
    types: {
      SOCIAL_FOLLOW: '{actor} 追蹤了你',
      SOCIAL_POST_LIKE: '{actor} 對你的貼文按讚',
      SOCIAL_POST_COMMENT: '{actor} 留言了你的貼文',
      SOCIAL_COMMENT_REPLY: '{actor} 回覆了你的留言',
      UNKNOWN: '你有一則新通知',
    },
    badge: {
      count: '{count} 個未讀通知',
      atLeast: '至少 {count} 個未讀通知',
      hasUnread: '有未讀通知',
    },
  },
  savedJourneys: {
    title: '收藏行程',
    subtitle: '您收藏供稍後查看的公開行程（不含社群貼文收藏）。',
    loading: '載入收藏行程…',
    loadFailedTitle: '無法載入收藏行程',
    emptyTitle: '尚未收藏任何公開行程',
    emptyHint: '在公開行程頁點擊收藏後，會顯示在這裡。',
    explore: '探索',
    savedAt: '收藏於 {time}',
  },
  saved: {
    title: '我的收藏',
    subtitle: '您收藏的貼文與公開行程，依收藏時間排序。',
    filterLabel: '收藏類型',
    filterAll: '全部',
    filterPosts: '貼文',
    filterJourneys: '行程',
    loading: '載入收藏…',
    loadFailedTitle: '無法載入收藏',
    emptyAllTitle: '尚未收藏任何內容',
    emptyAllHint: '在貼文或公開行程頁點擊收藏後，會顯示在這裡。',
    emptyPostsTitle: '尚未收藏任何貼文',
    emptyPostsHint: '在社群貼文頁點擊收藏後，會顯示在這裡。',
    emptyJourneysTitle: '尚未收藏任何公開行程',
    emptyJourneysHint: '在公開行程頁點擊收藏後，會顯示在這裡。想開始規劃時，可到公開行程頁複製，或建立全新行程。',
    explore: '探索',
    createBlankJourney: '建立全新行程',
    journeyNextStepsLabel: '收藏行程的下一步',
    journeyNextStepsHint: '收藏只是先記下來。要開始規劃請到公開行程頁複製；若要從頭規劃，可建立全新行程。',
    viewPublicJourney: '查看公開行程',
    startPlanningViaCopy: '複製並開始規劃',
    cardActionsLabel: '行程下一步',
    savedAt: '收藏於 {time}',
    typePost: '貼文',
    typeJourney: '行程',
    defaultPostTitle: '已收藏貼文',
    defaultJourneyTitle: '已收藏行程',
  },
  publicJourney: {
    loading: '載入行程中…',
    unavailable: '行程不可用',
    unavailableHint: '此行程可能不存在，或已不再公開。',
    loadFailedTitle: '無法載入此行程',
    tryAgain: '再試一次',
    backToExplore: '返回探索',
    publicItinerary: '公開行程',
    itineraryLoadFailed: '無法載入行程內容。',
    createGroupTrip: '建立揪團',
    publicGroupTrips: '公開揪團',
    sharedBy: '分享者',
    travelerFallback: '旅人',
    dayCount: '{count} 天',
    activityCount: '{count} 項安排',
    publishedRoute: '已發布路線',
    itinerary: '行程',
    itineraryUnavailableTitle: '公開行程內容暫不可用',
    itineraryUnavailableHint: '目前還沒有可顯示的行程內容。',
    mappedStops: '{count} 個地圖標記',
    dayHeading: '第 {number} 天',
    noMapPin: '無地圖標記',
    unscheduled: '未排程',
    noMappedLocation: '尚無地圖位置',
    timelineEyebrow: '旅程路線',
    timelineTitle: '旅程時間軸',
    sharedActivities: '{count} 則分享安排',
    timelineLoading: '載入路線中…',
    timelineUnavailable: '時間軸暫不可用',
    timelineRetry: '再試一次時間軸',
    timelineEmptyTitle: '目前還沒有公開安排',
    timelineEmptyHint: '尚未分享公開活動或回憶。',
    journeyMemory: '旅程回憶',
    loadMore: '載入更多',
    loadingMore: '載入中…',
    engagementLoadFailed: '無法載入你的互動狀態，請再試一次。',
    likeFailed: '無法更新按讚，請再試一次。',
    saveFailed: '無法更新收藏，請再試一次。',
    like: '按讚旅程',
    unlike: '取消按讚',
    save: '收藏旅程',
    unsave: '取消收藏',
    coverAlt: '{title} 的封面',
    actionGuideTitle: '想怎麼使用這趟行程？',
    actionGuideSave: '收藏：先記下來，之後可從「我的收藏」回來查看。',
    actionGuideCopy: '複製：建立一份你可編輯的行程，並進入規劃。',
    copyCta: '複製為我的行程',
    copyBusy: '複製中…',
    copyHint: '複製不會取得原行程的編輯權；成功後會前往你的規劃頁。',
    copySuccess: '已複製為你的行程，正在前往規劃',
    copyFailed: '目前無法複製此行程，請稍後再試。',
    copyUnavailable: '此行程目前不開放複製。',
    copyIntentFocus: '請確認下方「複製為我的行程」以開始規劃。',
  },
  copy: {
    source: {
      not: {
        available: '此行程目前無法查看',
      },
    },
    not: {
      allowed: '此行程目前無法複製',
    },
    disabled: '此行程不開放複製',
    validation: {
      failed: '請求參數不正確，請再試一次。',
    },
    idempotency: {
      conflict: '此次複製與先前請求衝突，請重新操作。',
    },
  },
  followingFeed: {
    brand: '旅遊社群',
    title: '追蹤中',
    compose: '發佈貼文',
    subtitle: '你追蹤的旅人所發佈的貼文。',
    loading: '載入追蹤動態…',
    errorTitle: '無法載入追蹤動態',
    retry: '重新整理',
    emptyTitle: '尚未看到追蹤中的新貼文',
    emptyHint: '可以前往探索找到感興趣的旅人或內容。',
    emptyCta: '前往探索',
    railLabel: '追蹤動態說明',
    railTitle: '只看你追蹤的人',
    railHint: '這裡會顯示你追蹤的旅人的新貼文。還沒有內容時，可以前往探索開始追蹤。',
    explore: '探索',
    loadMore: '載入更多',
    loadingMore: '載入中…',
    retryMore: '重試',
  },
  creator: {
    loading: '載入旅人頁面…',
    unavailableTitle: '找不到這位旅人',
    unavailableHint: '此頁面可能不存在，或目前無法查看。',
    backToExplore: '返回探索',
    loadFailedTitle: '無法載入此旅人',
    tryAgain: '再試一次',
    eyebrow: '旅人',
    follow: '追蹤',
    following: '已追蹤',
    updating: '更新中…',
    followFailed: '目前無法追蹤，請再試一次。',
    unfollowFailed: '目前無法取消追蹤，請再試一次。',
    tabsLabel: '旅人內容',
    postsTab: '貼文',
    journeysTab: '行程',
    loadingPosts: '載入貼文…',
    loadingJourneys: '載入行程…',
    postsLoadFailed: '無法載入貼文',
    journeysLoadFailed: '無法載入行程',
    emptyPostsTitle: '還沒有公開貼文',
    emptyPostsHint: '這位旅人尚未發佈公開貼文。',
    emptyOwnPostsHint: '發佈第一則旅遊故事，開始你的旅人頁面。',
    emptyJourneysTitle: '還沒有公開行程',
    emptyJourneysHint: '這位旅人尚未分享公開行程。',
    loadMorePosts: '載入更多貼文',
    loadMoreJourneys: '載入更多行程',
    loadingMore: '載入中…',
    end: '已顯示全部內容。',
    publicItinerary: '公開行程',
    dayActivityCount: '{days} 天 · {activities} 項安排',
    coverAlt: '{title} 的封面',
    quotedUnavailable: '引用的貼文目前無法查看',
    quotedFallback: '查看引用貼文',
    profileLoadFailed: '無法載入旅人頁面。',
    contentLoadFailed: '無法載入內容。',
    followersMetric: '追蹤者',
    followingMetric: '追蹤中',
    postsMetric: '貼文',
    journeysMetric: '行程',
    followersCountAria: '{name} 的追蹤者 {count} 人',
    followingCountAria: '{name} 追蹤中 {count} 人',
    followersTitle: '追蹤者',
    followingPeopleTitle: '追蹤中',
    followersEmptyTitle: '還沒有追蹤者',
    followersEmptyHint: '當有人追蹤這位旅人時，會顯示在這裡。',
    followingPeopleEmptyTitle: '還沒有追蹤任何人',
    followingPeopleEmptyHint: '這位旅人追蹤的對象會顯示在這裡。',
    connectionsLoading: '載入名單…',
    connectionsLoadFailedTitle: '無法載入名單',
    connectionsLoadFailed: '目前無法載入名單，請再試一次。',
    openCreatorProfile: '查看旅人頁面',
    editProfile: '編輯個人資料',
    editTitle: '編輯個人資料',
    editLead: '可修改暱稱與頭像。儲存後會更新你的旅人頁面與帳號顯示名稱。',
    closeEdit: '關閉編輯',
    nicknameLabel: '暱稱',
    nicknameHint: '最多 50 字，可留空。',
    nicknameTooLong: '暱稱不可超過 50 字。',
    avatarUpload: '上傳頭像',
    avatarUploading: '上傳中…',
    avatarRemove: '移除頭像',
    avatarUploadFailed: '頭像上傳失敗，請再試一次。',
    saveProfile: '儲存',
    saving: '儲存中…',
    profileSaved: '個人資料已更新。',
    profileSaveFailed: '無法儲存個人資料，請再試一次。',
    discardTitle: '捨棄未儲存的修改？',
    discardBody: '你有尚未儲存的變更。離開後這些修改會遺失。',
    discardConfirm: '捨棄修改',
  },
  groupTrip: {
    publicRecruitment: '公開招募',
    myGroupTrips: '我的揪團',
    createTitle: '建立揪團',
    publicListTitle: '公開揪團',
    publicListHint: '顯示正在招募、所有人都可以看到的揪團。追蹤者可見的揪團請透過分享連結開啟。',
    noPublicRecruitment: '目前沒有公開招募。',
    hostEmptyList: '你還沒有揪團。可以先選一個已發布的公開行程來發起。',
    notVisibleTitle: '揪團不可見',
    notVisibleHint: '可能不存在、尚未公開，或公開行程已不可讀。',
    backToPublicList: '返回公開招募',
    hostManageLink: '前往 Host 管理',
    runtimeTimelineTitle: '旅途紀錄',
    runtimePlannedTitle: '出發時的計畫',
    runtimeChangedTitle: '旅途中的變更',
    runtimeEmpty: '這趟還沒有旅途紀錄。',
    runtimeAdded: '旅途中新增',
    runtimeCancelled: '取消了活動',
    runtimeReplaced: '換成了另一個活動',
    runtimeTimeChanged: '調整了時間',
    runtimeParticipation: '參加狀態有變更',
    lateJoinTitle: '途中加入',
    lateJoinEntryBody: '這趟揪團已經在旅途中。你可以為自己提出加入，等主辦人決定。提出後不會先保留名額，也不代表一定能加入。',
    lateJoinRequest: '提出加入',
    lateJoinRequesting: '提出中',
    lateJoinEmptyTitle: '還沒有紀錄',
    lateJoinEmptyBody: '你還沒有提出過途中加入。',
    lateJoinPendingBody: '等待主辦人決定',
    lateJoinPendingCapacity: '這是現在的人數，不代表已為你保留。',
    lateJoinStatusPending: '待決定',
    lateJoinStatusApproved: '已加入',
    lateJoinStatusRejected: '未同意',
    lateJoinStatusCancelled: '已取消',
    lateJoinCancelAction: '取消這次請求',
    lateJoinCancelTitle: '取消這次請求？',
    lateJoinCancelBody: '取消後這筆會留在紀錄裡，狀態變成已取消。之後若仍符合條件，可以再提出。',
    lateJoinCancelConfirm: '確認取消',
    lateJoinNotYet: '先不要',
    lateJoinCancelledBody: '這次請求已取消。紀錄會留下來。畫面不猜是誰取消。',
    lateJoinRejectedBody: '主辦人沒有同意。你還沒有加入這趟揪團，人數也沒有因此改變。',
    lateJoinApprovedBody: '你已在旅途中加入。',
    lateJoinJoinAt: '加入時間 {when}',
    lateJoinResubmit: '再提出一次',
    lateJoinSamePending: '你已經有一筆等待決定的請求。再送一次不會多一張卡片。',
    lateJoinHostCapacity: '這是現在的人數。送出同意時才會再確認，不保證一定成功。',
    lateJoinHostCount: '目前 {occupied} / {capacity} 位。',
    lateJoinHostEmpty: '目前沒有待決定的請求。',
    lateJoinApprove: '同意加入',
    lateJoinReject: '拒絕',
    lateJoinRejectMeaning: '拒絕是不讓對方加入，和取消這筆請求不同。',
    lateJoinHostCancel: '取消這筆請求',
    lateJoinApproveTitle: '同意加入？',
    lateJoinApproveBody: '會成為這趟的同行者。不會收款、不會改訂位，也不會變成行程協作者。',
    lateJoinBack: '返回',
    lateJoinRejectTitle: '拒絕這次加入？',
    lateJoinRejectBody: '不會建立同行者，人數也不會改變。對方之後仍可再提出。',
    lateJoinHostCancelTitle: '取消這筆請求？',
    lateJoinHostCancelBody: '這不是拒絕。請求會留在紀錄裡，狀態變成已取消。',
    lateJoinCapacityFullTitle: '這次沒有完成',
    lateJoinCapacityFullBody: '目前名額不足，請求仍在待決定。',
    lateJoinTravelerContext: '旅途中加入 · 加入時間 {when}。時間由系統在同意時寫入，不能改。',
    lateJoinNotJoinedYet: '加入之前',
    lateJoinTimelineRequested: '提出途中加入',
    lateJoinTimelineCancelledByRequester: '提出的人取消了途中加入請求',
    lateJoinTimelineCancelledByHost: '主辦人取消了途中加入請求',
    lateJoinTimelineRejected: '主辦人沒有同意途中加入',
    lateJoinTimelineJoined: '在旅途中加入',
    lateJoinErrorNotTraveling: '這趟還沒有在旅途中，不能提出途中加入。',
    lateJoinErrorAlreadyTraveler: '你已經在這趟揪團裡。',
    lateJoinErrorRejoin: '離開或被移出後，不能用途中加入再回來。',
    lateJoinErrorHostCannotRequest: '主辦人不能對自己的揪團提出途中加入。',
    lateJoinErrorNotPending: '這筆已經結束，不能再做這個動作。',
    lateJoinErrorApprovedWithoutTraveler: '暫時無法顯示，請再試一次。',
    lateJoinErrorNotHost: '只有主辦人可以處理這筆請求。',
    lateJoinLoading: '讀取中',
    lateJoinLoadError: '目前無法載入，請再試一次。',
    lateJoinRetry: '再試一次',
    lateJoinCancelling: '取消中',
    lateJoinApproving: '同意中',
    lateJoinRejecting: '拒絕中',
    decisionTitle: '投票',
    decisionHint: '投票結果只供參考。行程要等主揪確認後才會變更。',
    decisionEmpty: '目前沒有投票。',
    decisionActivity: '要更換的活動',
    decisionPickActivity: '請選擇活動',
    decisionProposed: '建議換成',
    decisionCreate: '發起投票',
    decisionProgress: '{cast} / {eligible} 已投票',
    decisionKeep: '維持原案',
    decisionAwaiting: '等待主揪確認',
    decisionConfirmed: '已確認',
    decisionVoted: '已投票',
    decisionNotEligible: '不可投票，尚未綁定帳號',
    decisionClose: '結束投票',
    decisionConfirm: '確認並更新行程',
    viewPublicJourney: '查看公開行程',
    publicJourneyLink: '公開行程',
    backToList: '返回列表',
    applyNoteLabel: '申請備註',
    apply: '申請加入',
    withdrawApplication: '撤回申請',
    leave: '離開揪團',
    contactHost: '聯絡 Host',
    reserveSeat: '保留名額',
    abandonQualification: '放棄資格',
    confirmPayment: '確認付款',
    completeJoin: '完成加入',
    usePlatformWallet: '使用平台錢包付款',
    confirmingPayment: '正在確認付款…',
    paymentConfirmedJoining: '付款已確認，正在完成加入',
    approvedAwaitingPayment: '已核准 — 等待付款（名額已預留）。',
    approvedAwaitingPaymentNoSeat: '已核准 — 等待付款（尚未保留名額）。',
    approvedParticipant: '已核准加入',
    joinedParticipant: '已加入',
    paidJoined: '已付款 · 已加入揪團',
    paidCannotLeave: '已付款席次不可自行離開；Host 取消揪團時才會全額退款。',
    cancelPaidParticipation: '取消參加',
    cancelPaidConfirm: '取消後將退回本次付款全額。退款完成後名額才會釋出。',
    buyerRefundProcessing: '退款處理中。完成後名額才會釋出。',
    buyerRefundedWithdrawn: '已退款 · 已退出參加',
    buyerCancelAfterStart: '行程已開始，無法自行取消並退款。',
    tripPhaseLabel: '行程狀態：{phase}',
    tripPhase: {
      UPCOMING: '即將出發',
      IN_PROGRESS: '進行中',
      COMPLETED: '已結束',
      CANCELLING: '取消處理中',
      CANCELLED: '已取消',
    },
    pendingApplication: '申請已送出，等待主揪確認。',
    pendingApplicationHint: '主揪確認後才會正式加入。',
    participantStatus: '目前參加狀態：{status}',
    noDirectChatHint: '主揪與已加入的旅伴可開啟揪團群聊；也可透過私訊聯絡主揪。',
    groupChat: '群組聊天',
    chatOpening: '開啟中…',
    chatUnavailable: '群組聊天尚未就緒，請稍後再試。',
    chatOpenFailed: '無法開啟群組聊天',
    recruitmentClosedHint: '招募已關閉，無法再建立新的 TravelTrade。',
    noSlotsHint: '目前核准名額已滿，仍可送出申請；若之後有名額，主揪可再處理你的申請。',
    notFound: '找不到揪團',
    applications: '申請',
    noApplications: '尚無申請。',
    noticeApplicationUnavailable: '通知中的申請目前無法定位，已顯示此揪團全部申請。',
    noParticipants: '尚無旅伴。',
    partyHeading: '同行者',
    partySelf: '本人姓名',
    partyCompanion: '同行者姓名',
    addCompanion: '新增同行者',
    removeCompanion: '移除',
    partySize: '共 {count} 人',
    requestedSeats: '需要 {count} 個名額',
    travelersHeading: '出遊名單',
    guestLabel: '尚未綁定帳號',
    linkedLabel: '已綁定帳號',
    issueClaim: '發出加入連結',
    claimTokenHint: '請把這組連結交給對方。對方登入後即可加入，不會再佔新的名額。',
    claimAccept: '接受加入',
    claimAccepted: '已加入這趟揪團',
    noTravelers: '尚無出遊名單。',
    participationHeading: '活動參加',
    participationHint: '這只改變這個活動的參加狀態，不會退出揪團，也不會改變名額。',
    participationExpected: '預期參加',
    participationAway: '暫時離開此活動',
    participationEndAway: '回到此活動',
    participationSkipped: '跳過此活動',
    participationAttended: '已參加',
    participationClear: '恢復預期參加',
    participationNotJoining: '已不在這趟揪團',
    participationNotApplicable: '此活動已取消',
    participationIndependent: '不參加 · 獨立時段',
    d1Heading: '獨立行動',
    d1IndependentActive: '獨立行動中',
    d1ParticipationEnded: '已結束團體參與',
    d1Start: '開始獨立行動',
    d1End: '結束獨立行動',
    d1EndParticipation: '確認結束團體參與',
    d1EndWarning: '不會退出揪團、不會釋出名額，也不會自動取消訂位。',
    d1Cancel: '先不要',
    participationReason: '備註（選填）',
    noJourneyActivities: '這趟行程還沒有活動。',
    applicant: '申請人 {id}',
    member: '成員 {id}',
    approve: '核准',
    approveCapacityFullHint: '目前核准名額已滿，需有空出名額後才能核准。',
    reject: '拒絕',
    revokeApproval: '撤銷核准',
    remove: '移除',
    openRecruitment: '開啟招募',
    closeRecruitment: '關閉招募',
    hostCancel: '取消揪團',
    hostCancelling: '取消處理中',
    hostCancelled: '已取消',
    cancellingHint: '取消處理中。已付款席次需全額退款後才會完成取消。',
    cancelledHint: '已取消',
    refundProcessing: '退款處理中。已付款成員需全額退款；最終取消會在退款完成後生效。',
    paidRefundWarning: '已付款成員需全額退款；取消失敗或中斷時可再試，完成前不會顯示退款成功。',
    paidCannotRemove: '已付款 · 不可直接移除',
    recruitmentHint: '調整招募與旅伴名單只更新參加狀態。',
    occupancyBase: '名額 {cap} 人 · 目前參加 {occupied} 人 · 尚可接受 {slots} 人',
    occupancyFull: '名額 {cap} 人 · 目前參加 {occupied} 人 · 核准名額已滿',
    occupancyReserved: ' · 已預留 {reserved} 人 · 剩餘可加入 {commerce} 人',
    defaultTitle: 'Group trip',
    loadFailed: '無法載入揪團',
    applyFailed: '無法送出申請',
    withdrawFailed: '無法撤回申請',
    leaveFailed: '無法離開揪團',
    payFailed: '無法完成付款',
    joinFailed: '無法完成加入，請重試（不會重複扣款）',
    reserveFailed: '無法保留名額',
    createFailed: '無法建立揪團',
    createDraft: '建立草稿',
    creating: '建立中…',
    createCapacityHint: '名額是可加入人數上限；主揪不佔名額，也不需替自己送出申請。',
    hostVipBadge: 'Travel VIP',
    hostQuotaSummary: '進行中的揪團：{active}／{max}',
    invalidPublicationId: '需要有效的公開旅程才能建立揪團。',
    titleRequired: '請填招募標題',
    recruitmentTitleLabel: '招募標題',
    summaryLabel: '摘要',
    capacityInvalid: '參加名額至少為 1',
    dateRangeInvalid: '請填正確的開始／結束時間',
    editTitle: '編輯揪團草稿',
    editHint: '草稿可修改招募資訊；建立後起訖時間已鎖定。',
    editDraft: '編輯草稿',
    saveDraft: '儲存草稿',
    saving: '儲存中…',
    updateFailed: '無法更新揪團',
    editOnlyDraftHint: '此揪團已不是草稿，無法編輯。',
    backToDetail: '返回揪團詳情',
    cancelEdit: '取消',
    reloadAndRetry: '重新載入後再試',
    publicationIdLabel: '公開旅程',
    capacityLabel: '參加名額（主揪不佔）',
    startAtLabel: '開始時間',
    dateConflict: {
      title: '日期與你已確認的揪團重疊',
      body: '你在這段期間已確認加入或主辦其他揪團，因此無法加入這個揪團。若要改參加這團，請先依原揪團的規則退出。',
      openBody: '這段期間你已確認加入或主辦其他揪團，日期重疊，因此無法開放招募。',
      viewTrip: '查看原行程',
      tripListLabel: '日期重疊的揪團',
      busy: '目前有其他加入申請正在處理，請稍後再試一次。',
      pendingTitle: '申請已送出',
      pendingBody: '提醒：你另有待審核的揪團申請與此團日期重疊。若其中一團先被核准，另一團將無法加入。',
      applicantConflict: '這位申請人在此期間已確認加入其他揪團，日期重疊，因此無法核准。',
    },
    endAtLabel: '結束時間',
    visibilityLabel: '可見性',
    discovery: {
      filtersLabel: '找揪團',
      filtersDescription: '依關鍵字、出發日期與名額篩選公開揪團。',
      keywordLabel: '關鍵字',
      keywordPlaceholder: '搜尋標題或摘要',
      searchSubmit: '搜尋',
      startFromLabel: '出發時間（起）',
      startToLabel: '出發時間（迄）',
      startFromHint: '日期是揪團出發時間。',
      availableSlotsOnly: '只看尚有名額',
      sortLabel: '排序',
      sortLatest: '最新發布',
      sortStartAtAsc: '最近出發',
      clearFilters: '清除篩選',
      loadingMore: '載入更多中…',
      filterRefreshing: '更新結果中…',
      noFilterResults: '沒有符合條件的揪團',
      noFilterResultsHint: '試著調整關鍵字、出發時間或名額條件。',
      invalidDateRange: '出發時間（起）必須早於或等於出發時間（迄）。',
      departureAt: '出發：{time}',
    },
  },
  grouptrip: {
    validation: { failed: '請求參數不正確。' },
    not: { found: '找不到這筆揪團。' },
    application: { not: { found: '找不到這筆申請。' } },
    participant: { not: { found: '找不到這位旅伴。' } },
    permission: { denied: '沒有權限執行此操作。' },
    capacity: { exceeded: '名額已滿。' },
    invalid: { lifecycle: '目前狀態無法執行此操作。' },
    concurrent: { modification: '資料已被其他人更新，請重新整理後再試。' },
    date: {
      conflict: '你在這段期間已確認加入其他揪團，日期重疊，無法加入。',
      conflict_other: '這位申請人在此期間已確認加入其他揪團，日期重疊，因此無法核准。',
      check_busy: '目前有其他加入申請正在處理，請稍後再試一次。',
    },
    dates: { locked: '這趟旅程已綁定揪團，起訖日、天數與每日日期已鎖定；活動內容與時間仍可調整。' },
    conversation: {
      not: { found: '揪團群聊尚未建立。' },
      permission: { denied: '只有主揪或已加入的旅伴可開啟揪團群聊。' },
    },
  },
  trade: {
    validation: { failed: '交易請求參數不正確。' },
    not: { found: '找不到這筆交易。' },
    permission: { denied: '沒有權限執行此交易操作。' },
    payment: {
      failed: '錢包餘額不足，請稍後再試。',
      platform_fee_destination_unavailable: '平台手續費帳戶尚未就緒，暫無法完成付款。',
    },
    conflict: '目前無法建立或取消交易。',
    buyer_cancel: {
      not_allowed: '目前無法取消此已付款交易。',
      after_start: '行程已開始或已過出發時間，無法自行取消並退款。',
      after_release: '款項已進入撥付流程，無法取消並退款。',
    },
  },
  vip: {
    quota: { exceeded: '您同時進行中的 Host 揪團已達上限（上限 {0}，目前已 {1}）。' },
    member: { identity: { unavailable: '暫時無法讀取會員 VIP 身分，請稍後再試。' } },
    fee: {
      configuration: { invalid: 'VIP 手續費設定無效，請聯絡管理員。' },
      disclosureTitle: '平台服務費（目前生效）',
      platformFeeRate: '平台服務費率：{rate}',
      platformFeeRateVip: '平台服務費率：{rate}（VIP）',
      includedInDisplayPrice: '平台服務費已含於參加者顯示價格內；參加者不會另付「顯示價＋服務費」。',
      hostReceivableHint: '每筆付費參加的主揪實收約為顯示價格扣除平台服務費後的金額。',
      freeTripNoFee: '免費揪團不收取平台服務費。',
      disclosureLoadFailed: '無法載入平台服務費說明。',
    },
  },
  review: {
    sectionTitle: '旅伴評價',
    ratingLabel: '評分',
    contentPlaceholder: '分享您的旅行體驗（選填）',
    submitReview: '送出評價',
    submitting: '送出中…',
    deleteReview: '刪除評價',
    confirmDelete: '確定要刪除這則評價？',
    noReviews: '目前尚無評價。',
    loadMore: '載入更多評價',
    averageRating: '平均 {rating} 星',
    reviewCount: '{count} 則評價',
    noRatingYet: '尚無評價',
    hostReputationLabel: '主揪評價',
    eligibleHint: '行程已結束，您可以留下評價。',
    audiencePublic: '這是公開揪團：您的評價（評分、內容與您的公開顯示名稱）會公開顯示，任何人都看得到。評分也會計入主揪的公開平均評分。',
    audienceFollowers: '這個揪團僅限主揪的追蹤者觀看：您的評價（評分、內容與您的公開顯示名稱）會依此揪團的追蹤者範圍顯示，只有主揪、旅伴與主揪的追蹤者看得到。評分也會計入主揪的公開平均評分。',
    audiencePrivate: '這是私人揪團：您的評價（評分、內容與您的公開顯示名稱）只有這個揪團的主揪與旅伴看得到。評分也會計入主揪的公開平均評分。',
    listUnavailable: '目前無法查看這個揪團的評價。',
    alreadyReviewed: '您已留下評價。',
    notEligible: '您目前無法評價此揪團。',
    loadFailed: '無法載入評價',
    submitFailed: '無法送出評價',
    deleteFailed: '無法刪除評價',
    eligibilityLoadFailed: '無法讀取評價資格',
    stars: (n) => '★'.repeat(n) + '☆'.repeat(5 - n),
    already_exists: '您已提交過評價。',
    deleted: '您先前提交的評價已被刪除，無法再次提交。',
    not_eligible: '您目前沒有評價資格。',
    not_found: '找不到這則評價。',
    permission: { denied: '沒有權限刪除此評價。' },
    validation: { failed: '評價請求參數不正確。' },
    concurrent: { modification: '資料已被更新，請重試。' },
  },
  commerce: {
    currency: {
      unsupported: '此幣別目前不支援付費揪團',
    },
    earnings: {
      title: '收益與交易',
      subtitle: '依歷史成交快照顯示，不含提領或結算。',
      gross: '交易總額',
      grossHint: '含已退款成交量，不是已實現收入。',
      platform_fee: '平台服務費',
      host_receivable: '主揪應收',
      pending_release: '待撥付',
      released: '已撥付',
      refunded: '已退款',
    },
    history: {
      title: '交易紀錄',
      empty: '目前沒有符合條件的交易。',
      loadFailed: '無法載入收益與交易',
      filterGroupTrip: '揪團',
      filterGroupTripAll: '全部揪團',
      filterStatus: '狀態',
      filterStatusAll: '全部狀態',
      buyer: '買家',
      buyerFallback: '旅伴',
      gross: '交易金額',
      platform_fee: '平台服務費',
      host_receivable: '主揪應收',
      paidAt: '付款時間',
      releasedAt: '撥付時間',
      refundedAt: '退款時間',
      createdAt: '建立時間',
      status: {
        AWAITING_PAYMENT: '待付款',
        PAID_PENDING_RELEASE: '待撥付',
        RELEASED: '已撥付',
        REFUNDED: '已退款',
        CANCELLED: '已取消',
      },
    },
  },
  safety: {
    report: '檢舉',
    block: '封鎖',
    reportHost: '檢舉主揪',
    blockHost: '封鎖主揪',
    reportParticipant: '檢舉旅伴',
    blockParticipant: '封鎖旅伴',
    reportMember: '檢舉會員',
    reportPost: '檢舉貼文',
    reportContent: '檢舉內容',
    reportGroupTrip: '檢舉此揪團',
    reason: '檢舉原因',
    optionalNote: '補充說明（選填）',
    submitReport: '送出檢舉',
    submitting: '送出中…',
    cancel: '取消',
    close: '關閉',
    reportSubmitted: '已送出檢舉，我們會進行審核。',
    reportFailed: '無法送出檢舉',
    blockConfirm: '確定要封鎖此會員？封鎖後仍不會自動取消揪團或退款。',
    confirmBlock: '確認封鎖',
    blocking: '封鎖中…',
    memberBlocked: '已封鎖',
    blockFailed: '無法封鎖',
    actionFailed: '安全操作失敗',
    authRequired: '請先登入後再進行檢舉或封鎖。',
    reasons: {
      SPAM: '垃圾訊息',
      HARASSMENT: '騷擾',
      HATE_OR_ABUSE: '仇恨或辱罵',
      SEXUAL_CONTENT: '不當性內容',
      VIOLENCE: '暴力',
      SCAM_OR_FRAUD: '詐騙或欺詐',
      IMPERSONATION: '冒充身份',
      PRIVACY: '隱私侵害',
      MISINFORMATION: '不實資訊',
      OTHER: '其他',
    },
  },
  social: {
    safety: {
      block: {
        self: { not: { allowed: '不可封鎖自己' } },
        relationship: { conflict: '封鎖狀態衝突，請重試' },
      },
      report: {
        self: { not: { allowed: '不可檢舉自己' } },
        target: { not: { found: '找不到檢舉對象' } },
        invalid: { reason: '檢舉原因無效' },
        idempotency: { conflict: '檢舉請求衝突，請重試' },
      },
      validation: { failed: '安全請求參數不正確' },
    },
  },
};

export const travelEnUS = {
  discover: {
    title: 'Discover',
    subtitle: 'Browse public travel stories and journeys, then decide what to follow or save.',
    compose: 'Create post',
    tabsLabel: 'Discover tabs',
    railLabel: 'Discover information',
    railTitle: 'How stories connect to journeys',
    railHint: 'Posts often link to public journeys. Open a journey for the route, then keep browsing Discover.',
    firstUse: {
      guestLead: 'First time here? Start with this:',
      guestPost: 'Read public travel stories in For you',
      guestJourney: 'Browse public journeys in Trips or the side panel',
      guestLogin: 'Likes, saves, follows, and publishing need sign-in',
    },
    tabs: {
      forYou: 'For you',
      journeys: 'Trips',
      social: 'Posts',
    },
    kinds: {
      ALL: 'All',
      MOOD: 'Mood',
      JOURNEY: 'Journey',
      JOURNEY_INVITATION: 'Journey invite',
      PLACE: 'Place',
      FOOD: 'Food',
    },
    posts: {
      viewLabel: 'Posts view',
      list: 'List',
      map: 'Map',
      location: 'Place',
      kind: 'Type',
      allLocations: 'All places',
      following: 'Following',
      followingHint: 'Only people you follow',
      showOnMap: 'View on map',
      filtersLabel: 'Post filters',
      publicJourney: 'Public journey',
      openPublishedJourney: 'Open the published route and map',
      journeyUnavailable: 'This journey is unavailable right now',
    },
    locationSelector: {
      root: 'All places',
      selectedPrefix: 'Selected: ',
      back: 'Back',
      clear: 'Clear location',
      loading: 'Loading locations…',
      loadFailed: 'Locations could not be loaded.',
      use: 'Use this location',
      selected: 'Selected',
      openChildren: 'Open children',
      empty: 'No named locations at this level.',
    },
    loading: 'Loading…',
    end: "You're all caught up.",
    notInterested: 'Not interested',
    mute: 'Mute creator',
    hideContent: 'Hide this content',
    days: 'days',
    viewJourney: 'View journey',
    contentType: {
      journey: 'Public journey',
      socialPost: 'Travel story',
    },
    empty: {
      title: 'Nothing here yet',
      hint: 'Check back soon for personalised recommendations.',
      guestHint: 'Nothing to recommend yet. Browse public journeys, or sign in and check back later.',
    },
    error: {
      title: 'Could not load',
      loadFailed: 'Could not load journeys.',
      postsLoadFailed: 'Could not load posts.',
      actionFailed: 'Action failed. Please try again.',
    },
    journeys: {
      emptyTitle: 'No journeys found',
      emptyHint: 'Try adjusting your filters.',
      emptyWithQuery: 'No journeys matched “{q}”. Try another keyword or clear search.',
    },
    filters: {
      label: 'Journey filters',
      location: 'Location',
      allLocations: 'All locations',
      clearLocation: 'Clear location',
      selectedLocation: 'Selected location',
      budgetMin: 'Budget min',
      budgetMax: 'Budget max',
      currency: 'Currency',
      minDays: 'Min days',
      maxDays: 'Max days',
      sort: 'Sort',
      apply: 'Apply',
      reset: 'Reset',
    },
    search: {
      label: 'Search journeys',
      placeholder: 'Tokyo, Kyoto, 東京…',
      submit: 'Search',
      clear: 'Clear',
      context: 'Searching for “{q}”',
    },
    suggestions: {
      loading: 'Loading suggestions…',
      empty: 'No suggestions. Press Enter to search.',
      error: 'Suggestions unavailable. Press Enter to search.',
      type: {
        geo: 'Location',
        journey: 'Journey',
      },
    },
    sort: {
      latest: 'Latest',
      hot: 'Hot',
    },
  },
  nav: {
    brand: 'Formosa Travel',
    explore: 'Explore',
    journeys: 'Trips',
    groupTripDiscover: 'Group trips',
    me: 'Me',
    primary: 'Primary navigation',
    primaryMobile: 'Mobile primary navigation',
    notificationCenter: 'Notifications',
    saved: 'Saved',
    messages: 'Messages',
    myJourneys: 'My Journeys',
    findGroupTrips: 'Find group trips',
    groupTrips: 'My group trips',
    earnings: 'Earnings & trades',
    invitations: 'Invitations',
    notices: 'Group trip notices',
    notifications: 'Notifications',
    publicGroupTrips: 'Public Group Trips',
    more: 'More',
    profile: 'My creator profile',
    signIn: 'Sign in',
    signOut: 'Sign out',
    register: 'Register',
    signInRegister: 'Sign in / Register',
    checkingSession: 'Checking your session…',
    member: 'Member',
    language: 'Language',
  },
  auth: {
    googleContinue: 'Continue with Google',
    googleConnecting: 'Connecting…',
    googleUnavailable: 'Google sign-in is unavailable (missing configuration).',
  },
  places: {
    searchLabel: 'Search places',
    searchPlaceholder: 'Type a place name',
    resolving: 'Confirming place…',
    searching: 'Searching…',
    loadingProvider: 'Loading place search…',
    candidatesLabel: 'Place candidates',
  },
  direct: {
    errors: {
      unavailable: 'Unable to message this traveler right now.',
      privacyDenied: 'This traveler is not accepting new private messages.',
      chatDisabled: 'New conversations are temporarily unavailable. Please try again later.',
      accountCannotUse: 'This account cannot use private messages right now.',
      peerNotFound: 'This traveler could not be found.',
      authExpired: 'Your session has expired. Please sign in and try again.',
      network: 'Network is temporarily unavailable. Please try again later.',
      startFailed: 'Unable to start the conversation. Please try again later.',
    },
  },

  discoverGuest: {
    title: 'Sign in to keep exploring',
    body: 'Likes, saves, comments, follows, and map explore need sign-in. You can still read public stories in For you.',
    followingTitle: 'Sign in to see Following',
    followingBody: 'Following shows posts from travelers you follow. After sign-in you will return to this tab.',
    mapTitle: 'Sign in to explore the travel map',
    mapBody: 'Map explore needs sign-in. After sign-in you will return here, or browse For you first.',
    socialTitle: 'Sign in for post explore',
    socialBody: 'This posts explore view needs sign-in. You can still read public stories and journeys in For you.',
    cta: 'Sign in to continue',
    browseForYou: 'Browse For you first',
    footnote: 'After sign-in you will return to the page you were viewing.',
    engagementNotice: 'Sign in to like, save, or comment, then return to this page.',
  },
  journeyWorkspace: {
    overviewHint: 'Set where this trip goes, which days it covers, and basic trip details.',
    planningHint: 'Plan what to do each day, with times and places.',
  },
  journeyCost: {
    disclaimer: 'This feature only helps track spending and splits. It does not mean the platform paid on your behalf.',
    actions: {
      refresh: 'Refresh',
      cancel: 'Cancel',
      confirm: 'Confirm',
      saving: 'Saving…',
      reloadBudget: 'Reload latest budget',
    },
    budget: {
      total: 'Total budget',
      spent: 'Recorded spend',
      remaining: 'Remaining',
      currency: 'Currency',
      allocated: 'Allocated',
      unallocated: 'Unallocated',
      baseCurrencyHint: 'Base currency · single journey',
      allocatedHint: 'Sum of category limits',
      unallocatedHint: 'Total − allocated',
      actualOnExpenses: 'Recorded spend lives on Expenses; this page shows budget allocation only.',
      openExpenses: 'Open expenses',
      edit: 'Edit budget',
      create: 'Create budget',
      save: 'Save budget',
      categoryLegend: 'Category allocation',
      allocatedPreview: 'Allocated preview',
      unallocatedPreview: 'Unallocated preview',
      openFailed: 'We couldn’t open budget',
      validation: 'Please check the budget values.',
      forbidden: 'You do not have permission to change this budget.',
      lifecycle: 'Budget cannot be changed in the current journey status.',
      alreadyExists: 'Budget already exists. Reload to edit it.',
      readonlyRole: 'Read-only: only Owner or Coordinator can change the budget.',
      readonlyLifecycle: 'Read-only: budget cannot be changed in the current journey status.',
      confirmCreateTitle: 'Confirm create budget?',
      confirmReplaceTitle: 'Confirm replace budget?',
      confirmCreateBody: 'This will set the journey budget with the values you entered.',
      confirmReplaceBody: 'This replaces the full budget and category allocations.',
      emptyTitle: 'No travel budget yet',
      setup: 'Set budget',
      conflict: 'The budget was updated elsewhere. Reload the latest budget.',
      currencyMismatch: 'Budget currency must match the journey currency.',
      validationErrors: {
        currencyRequired: 'Currency is required (ISO 4217).',
        baselineInvalid: 'Total budget must be a valid non-negative amount.',
        baselineNegative: 'Total budget must be non-negative.',
        categoriesRequired: 'At least one category allocation is required.',
        categoryUnknown: 'Unknown category: {category}',
        categoryAmountInvalid: '{category} amount is invalid.',
        categoryAmountNegative: '{category} must be non-negative.',
        allocationExceedsTotal: 'Category allocations cannot exceed total budget.',
      },
    },
    categories: {
      ACCOMMODATION: 'Accommodation',
      TRANSPORT: 'Transport',
      FOOD: 'Food',
      TICKET: 'Ticket',
      SHOPPING: 'Shopping',
      INSURANCE: 'Insurance',
      COMMUNICATION: 'Communication',
      OTHER: 'Other',
    },
    expense: {
      statusAll: 'All',
      statusActive: 'Active',
      statusVoided: 'Voided',
      splitPreview: 'Split preview (server result is final)',
    },
    split: {
      settlementTitle: 'Settlement suggestions (for reference only)',
      settlementCopy: 'These suggestions help members settle among themselves. The platform does not collect, pay, or mark settled.',
      confirmNotPayment: 'Please confirm you understand: this is not a payment flow.',
      statusCurrent: 'Current',
      statusOutdated: 'Outdated',
      statusEmpty: 'Not calculated',
    },
  },
  common: {
    travel: 'Travel',
    loading: 'Loading…',
    retry: 'Retry',
    loadMore: 'Load more',
    loadFailed: 'Failed to load',
    actionFailed: 'Action failed. Please try again later.',
    empty: 'No data yet',
    back: 'Back',
    cancel: 'Cancel',
    read: 'Read',
    host: 'Host',
    participants: 'Participants',
    apiError: {
      network: {
        title: 'Network connection failed',
        description: 'Check your connection and try again.',
      },
      unauthorized: {
        title: 'Session expired',
        description: 'Please sign in again to continue.',
      },
      forbidden: {
        title: 'Permission denied',
        description: 'You cannot perform this action.',
      },
      notFound: {
        title: 'Not found',
        description: 'The requested content is missing or was removed.',
      },
      validation: {
        title: 'Invalid input',
        description: 'Please check your input and try again.',
      },
      conflict: {
        title: 'Content was updated',
        description: 'Refresh and try again.',
      },
      rateLimited: {
        title: 'Too many requests',
        description: 'Please try again later.',
      },
      unavailable: {
        title: 'Service unavailable',
        description: 'Please try again shortly.',
      },
      server: {
        title: 'Something went wrong',
        description: 'Please try again shortly.',
      },
      domain: {
        title: 'Unable to complete',
        description: 'Please try again later.',
      },
      unknown: {
        title: 'Something went wrong',
        description: 'Please try again shortly.',
      },
    },
  },
  groupTripNotice: {
    title: 'Group trip notices',
    types: {
      APPLICATION_RECEIVED: 'New join request',
      APPLICATION_APPROVED: 'Joined successfully',
      APPLICATION_REJECTED: 'Application result',
      APPLICATION_WITHDRAWN: 'Application withdrawn',
      PARTICIPANT_REMOVED: 'Participation changed',
      PARTICIPANT_LEFT: 'Member left',
      GROUP_TRIP_CANCELLED: 'Trip cancelled',
      GROUP_TRIP_STARTING_SOON: 'Starting soon',
      UNKNOWN: 'Group trip notice',
    },
    messages: {
      APPLICATION_RECEIVED: 'Your group trip received a new join request',
      APPLICATION_APPROVED: 'You have successfully joined this group trip',
      APPLICATION_REJECTED: 'Your join request was not approved',
      APPLICATION_WITHDRAWN: 'A join request was withdrawn',
      PARTICIPANT_REMOVED: 'You have been removed from this group trip',
      PARTICIPANT_LEFT: 'A member left this group trip',
      GROUP_TRIP_CANCELLED: 'This group trip has been cancelled',
      GROUP_TRIP_STARTING_SOON: 'This group trip is starting soon. Please review the meetup and itinerary details.',
    },
    unread: 'Unread',
    markRead: 'Mark as read',
    markAll: 'Mark all as read',
    markAllDone: 'All notices marked as read',
    empty: 'No group trip notices yet',
    emptyDescription: 'Join requests and trip updates will show up here.',
    lead: 'Follow join requests and trip changes.',
    error: 'Unable to load group trip notices',
    actionFailed: 'Action failed. Please try again.',
    loadMore: 'Load more notices',
    openTrip: 'View group trip',
  },
  notificationCenter: {
    relatedAria: 'Other notification entries',
    relatedLabel: 'Other entries',
    announcements: 'Announcements',
    siteMail: 'Inbox mail',
  },
  socialNotification: {
    title: 'Notifications',
    bell: 'Notifications',
    someone: 'Someone',
    unread: 'Unread',
    markRead: 'Mark as read',
    markAll: 'Mark all as read',
    markAllDone: 'All notifications marked as read',
    empty: 'No notifications yet.',
    emptyDescription: 'Follows, likes, and comments will show up here.',
    lead: 'See social activity and recent updates.',
    error: 'Unable to load notifications',
    actionFailed: 'Action failed. Please try again.',
    loadMore: 'Load more notifications',
    types: {
      SOCIAL_FOLLOW: '{actor} followed you',
      SOCIAL_POST_LIKE: '{actor} liked your post',
      SOCIAL_POST_COMMENT: '{actor} commented on your post',
      SOCIAL_COMMENT_REPLY: '{actor} replied to your comment',
      UNKNOWN: 'You have a new notification',
    },
    badge: {
      count: '{count} unread notifications',
      atLeast: 'At least {count} unread notifications',
      hasUnread: 'You have unread notifications',
    },
  },
  savedJourneys: {
    title: 'Saved journeys',
    subtitle: 'Public itineraries you saved for later (not social post saves).',
    loading: 'Loading saved journeys…',
    loadFailedTitle: 'Unable to load saved journeys',
    emptyTitle: 'No saved public journeys yet',
    emptyHint: 'Save a public journey and it will appear here.',
    explore: 'Explore',
    savedAt: 'Saved {time}',
  },
  saved: {
    title: 'Saved',
    subtitle: 'Posts and public journeys you saved, ordered by save time.',
    filterLabel: 'Saved type',
    filterAll: 'All',
    filterPosts: 'Posts',
    filterJourneys: 'Journeys',
    loading: 'Loading saved items…',
    loadFailedTitle: 'Unable to load saved items',
    emptyAllTitle: 'Nothing saved yet',
    emptyAllHint: 'Save a post or public journey and it will appear here.',
    emptyPostsTitle: 'No saved posts yet',
    emptyPostsHint: 'Save a social post and it will appear here.',
    emptyJourneysTitle: 'No saved public journeys yet',
    emptyJourneysHint: 'Save a public journey and it will appear here. To start planning, copy from the public journey page, or create a blank journey.',
    explore: 'Explore',
    createBlankJourney: 'Create blank journey',
    journeyNextStepsLabel: 'Next steps for saved journeys',
    journeyNextStepsHint: 'Saving only bookmarks the public journey. Copy it on the public page to start planning, or create a blank journey from scratch.',
    viewPublicJourney: 'View public journey',
    startPlanningViaCopy: 'Copy and start planning',
    cardActionsLabel: 'Journey next steps',
    savedAt: 'Saved {time}',
    typePost: 'Post',
    typeJourney: 'Journey',
    defaultPostTitle: 'Saved post',
    defaultJourneyTitle: 'Saved journey',
  },
  publicJourney: {
    loading: 'Loading journey…',
    unavailable: 'Journey unavailable',
    unavailableHint: 'This journey may not exist or may no longer be public.',
    loadFailedTitle: 'We couldn’t load this journey',
    tryAgain: 'Try again',
    backToExplore: 'Back to Explore',
    publicItinerary: 'Public itinerary',
    itineraryLoadFailed: 'The journey could not be loaded.',
    createGroupTrip: 'Create group trip',
    publicGroupTrips: 'Public group trips',
    sharedBy: 'Shared by',
    travelerFallback: 'Traveler',
    dayCount_one: '{count} day',
    dayCount: '{count} days',
    activityCount_one: '{count} activity',
    activityCount: '{count} activities',
    publishedRoute: 'Published route',
    itinerary: 'Itinerary',
    itineraryUnavailableTitle: 'Published itinerary is not available',
    itineraryUnavailableHint: 'There is no itinerary to show yet.',
    mappedStops_one: '{count} mapped stop',
    mappedStops: '{count} mapped stops',
    dayHeading: 'Day {number}',
    noMapPin: 'No map pin',
    unscheduled: 'Unscheduled',
    noMappedLocation: 'No mapped location',
    timelineEyebrow: 'The route',
    timelineTitle: 'Journey timeline',
    sharedActivities_one: '{count} shared activity',
    sharedActivities: '{count} shared activities',
    timelineLoading: 'Loading the route…',
    timelineUnavailable: 'Timeline unavailable',
    timelineRetry: 'Try timeline again',
    timelineEmptyTitle: 'A quiet itinerary',
    timelineEmptyHint: 'No public activities or memories have been shared yet.',
    journeyMemory: 'Journey memory',
    loadMore: 'Load more',
    loadingMore: 'Loading…',
    engagementLoadFailed: 'Could not load your journey actions. Try again.',
    likeFailed: 'Could not update like. Try again.',
    saveFailed: 'Could not update save. Try again.',
    like: 'Like journey',
    unlike: 'Unlike journey',
    save: 'Save journey',
    unsave: 'Unsave journey',
    coverAlt: 'Cover for {title}',
    actionGuideTitle: 'How do you want to use this journey?',
    actionGuideSave: 'Save: bookmark it so you can find it later in Saved.',
    actionGuideCopy: 'Copy: create your own editable journey and open Planning.',
    copyCta: 'Copy as my journey',
    copyBusy: 'Copying…',
    copyHint: 'Copy does not grant edit access to the original. You will go to your Planning page after success.',
    copySuccess: 'Copied as your journey — opening Planning',
    copyFailed: 'This journey can’t be copied right now. Please try again later.',
    copyUnavailable: 'This journey is not open for copying.',
    copyIntentFocus: 'Confirm “Copy as my journey” below to start planning.',
  },
  copy: {
    source: {
      not: {
        available: '此行程目前無法查看',
      },
    },
    not: {
      allowed: '此行程目前無法複製',
    },
    disabled: '此行程不開放複製',
    validation: {
      failed: '請求參數不正確，請再試一次。',
    },
    idempotency: {
      conflict: '此次複製與先前請求衝突，請重新操作。',
    },
  },
  followingFeed: {
    brand: 'Travel social',
    title: 'Following',
    compose: 'Create post',
    subtitle: 'Posts from people you follow.',
    loading: 'Loading following…',
    errorTitle: 'Could not load following',
    retry: 'Refresh',
    emptyTitle: 'No new posts from people you follow',
    emptyHint: 'Explore to find travelers or stories you like.',
    emptyCta: 'Explore',
    railLabel: 'Following help',
    railTitle: 'Only people you follow',
    railHint: 'New posts from people you follow appear here. If it is empty, explore to start following.',
    explore: 'Explore',
    loadMore: 'Load more',
    loadingMore: 'Loading…',
    retryMore: 'Retry',
  },
  creator: {
    loading: 'Loading traveler…',
    unavailableTitle: 'Traveler unavailable',
    unavailableHint: 'This profile may not exist or is not available.',
    backToExplore: 'Back to Explore',
    loadFailedTitle: 'Could not load this traveler',
    tryAgain: 'Try again',
    eyebrow: 'Traveler',
    follow: 'Follow',
    following: 'Following',
    updating: 'Updating…',
    followFailed: 'Could not follow. Try again.',
    unfollowFailed: 'Could not unfollow. Try again.',
    tabsLabel: 'Traveler content',
    postsTab: 'Posts',
    journeysTab: 'Journeys',
    loadingPosts: 'Loading posts…',
    loadingJourneys: 'Loading journeys…',
    postsLoadFailed: 'Could not load posts',
    journeysLoadFailed: 'Could not load journeys',
    emptyPostsTitle: 'No public posts yet',
    emptyPostsHint: 'This traveler has not published a public post.',
    emptyOwnPostsHint: 'Share your first travel story to start this page.',
    emptyJourneysTitle: 'No public journeys yet',
    emptyJourneysHint: 'This traveler has not shared a public journey.',
    loadMorePosts: 'Load more posts',
    loadMoreJourneys: 'Load more journeys',
    loadingMore: 'Loading…',
    end: 'You have reached the end.',
    publicItinerary: 'Public itinerary',
    dayActivityCount: '{days} days · {activities} activities',
    coverAlt: 'Cover for {title}',
    quotedUnavailable: 'Quoted post unavailable',
    quotedFallback: 'View quoted post',
    profileLoadFailed: 'Creator profile could not be loaded.',
    contentLoadFailed: 'Content could not be loaded.',
    followersMetric: 'Followers',
    followingMetric: 'Following',
    postsMetric: 'Posts',
    journeysMetric: 'Journeys',
    followersCountAria: '{count} followers of {name}',
    followingCountAria: '{name} following {count}',
    followersTitle: 'Followers',
    followingPeopleTitle: 'Following',
    followersEmptyTitle: 'No followers yet',
    followersEmptyHint: 'People who follow this traveler will appear here.',
    followingPeopleEmptyTitle: 'Not following anyone yet',
    followingPeopleEmptyHint: 'People this traveler follows will appear here.',
    connectionsLoading: 'Loading list…',
    connectionsLoadFailedTitle: 'Could not load list',
    connectionsLoadFailed: 'Could not load this list. Try again.',
    openCreatorProfile: 'Open creator profile',
    editProfile: 'Edit profile',
    editTitle: 'Edit profile',
    editLead: 'You can update your nickname and avatar. Changes appear on your creator page and account display name.',
    closeEdit: 'Close editor',
    nicknameLabel: 'Nickname',
    nicknameHint: 'Up to 50 characters. Leave blank to clear.',
    nicknameTooLong: 'Nickname must be 50 characters or fewer.',
    avatarUpload: 'Upload avatar',
    avatarUploading: 'Uploading…',
    avatarRemove: 'Remove avatar',
    avatarUploadFailed: 'Avatar upload failed. Try again.',
    saveProfile: 'Save',
    saving: 'Saving…',
    profileSaved: 'Profile updated.',
    profileSaveFailed: 'Could not save profile. Try again.',
    discardTitle: 'Discard unsaved changes?',
    discardBody: 'You have unsaved changes. If you leave now, they will be lost.',
    discardConfirm: 'Discard',
  },
  groupTrip: {
    publicRecruitment: 'Public recruitment',
    myGroupTrips: 'My group trips',
    createTitle: 'Create group trip',
    publicListTitle: 'Public group trips',
    publicListHint: 'Shows open recruitments visible to everyone. Follower-only trips open via shared link.',
    noPublicRecruitment: 'No public recruitment right now.',
    hostEmptyList: 'You have no group trips yet. Pick a published public journey to start one.',
    notVisibleTitle: 'Group trip unavailable',
    notVisibleHint: 'It may not exist, is not public yet, or the publication is no longer readable.',
    backToPublicList: 'Back to public list',
    hostManageLink: 'Host management',
    runtimeTimelineTitle: 'Trip record',
    runtimePlannedTitle: 'Plan at departure',
    runtimeChangedTitle: 'Changes during the trip',
    runtimeEmpty: 'This trip has no runtime record yet.',
    runtimeAdded: 'Added during the trip',
    runtimeCancelled: 'Activity cancelled',
    runtimeReplaced: 'Activity replaced',
    runtimeTimeChanged: 'Time changed',
    runtimeParticipation: 'Participation changed',
    lateJoinTitle: 'Join during the trip',
    lateJoinEntryBody: 'This group trip is already traveling. You can ask to join for yourself and wait for the host. Asking does not hold a seat and does not mean you will get in.',
    lateJoinRequest: 'Ask to join',
    lateJoinRequesting: 'Sending',
    lateJoinEmptyTitle: 'No record yet',
    lateJoinEmptyBody: 'You have not asked to join during the trip.',
    lateJoinPendingBody: 'Waiting for the host',
    lateJoinPendingCapacity: 'This is the current headcount. It does not mean a seat is held for you.',
    lateJoinStatusPending: 'Waiting',
    lateJoinStatusApproved: 'Joined',
    lateJoinStatusRejected: 'Not accepted',
    lateJoinStatusCancelled: 'Cancelled',
    lateJoinCancelAction: 'Cancel this request',
    lateJoinCancelTitle: 'Cancel this request?',
    lateJoinCancelBody: 'It stays in your record and becomes cancelled. You can ask again later if you still qualify.',
    lateJoinCancelConfirm: 'Confirm cancel',
    lateJoinNotYet: 'Not now',
    lateJoinCancelledBody: 'This request was cancelled. The record stays. This screen does not guess who cancelled it.',
    lateJoinRejectedBody: 'The host did not accept. You have not joined, and the headcount did not change.',
    lateJoinApprovedBody: 'You joined during the trip.',
    lateJoinJoinAt: 'Joined at {when}',
    lateJoinResubmit: 'Ask again',
    lateJoinSamePending: 'You already have a request waiting. Sending again does not add another card.',
    lateJoinHostCapacity: 'This is the current headcount. It is checked again when you accept, and acceptance is not guaranteed.',
    lateJoinHostCount: 'Now {occupied} / {capacity}.',
    lateJoinHostEmpty: 'No requests are waiting.',
    lateJoinApprove: 'Accept',
    lateJoinReject: 'Decline',
    lateJoinRejectMeaning: 'Decline means they will not join. It is not the same as cancelling the request.',
    lateJoinHostCancel: 'Cancel this request',
    lateJoinApproveTitle: 'Accept this join?',
    lateJoinApproveBody: 'They become a traveler on this trip. This does not take payment, change a booking, or make them a journey collaborator.',
    lateJoinBack: 'Back',
    lateJoinRejectTitle: 'Decline this join?',
    lateJoinRejectBody: 'No traveler is created and the headcount does not change. They can ask again later.',
    lateJoinHostCancelTitle: 'Cancel this request?',
    lateJoinHostCancelBody: 'This is not a decline. The request stays in the record and becomes cancelled.',
    lateJoinCapacityFullTitle: 'Not completed',
    lateJoinCapacityFullBody: 'There is no room right now. The request is still waiting.',
    lateJoinTravelerContext: 'Joined during the trip · {when}. The time was written when the host accepted and cannot be changed.',
    lateJoinNotJoinedYet: 'Before they joined',
    lateJoinTimelineRequested: 'Asked to join during the trip',
    lateJoinTimelineCancelledByRequester: 'The person who asked cancelled the join request',
    lateJoinTimelineCancelledByHost: 'The host cancelled the join request',
    lateJoinTimelineRejected: 'The host did not accept the join',
    lateJoinTimelineJoined: 'Joined during the trip',
    lateJoinErrorNotTraveling: 'This trip is not traveling yet, so you cannot ask to join during the trip.',
    lateJoinErrorAlreadyTraveler: 'You are already on this trip.',
    lateJoinErrorRejoin: 'After leaving or being removed, you cannot come back through this.',
    lateJoinErrorHostCannotRequest: 'The host cannot ask to join their own trip.',
    lateJoinErrorNotPending: 'This request is already finished, so that action is no longer available.',
    lateJoinErrorApprovedWithoutTraveler: 'This cannot be shown right now. Please try again.',
    lateJoinErrorNotHost: 'Only the host can handle this request.',
    lateJoinLoading: 'Loading',
    lateJoinLoadError: 'This could not be loaded. Please try again.',
    lateJoinRetry: 'Try again',
    lateJoinCancelling: 'Cancelling',
    lateJoinApproving: 'Accepting',
    lateJoinRejecting: 'Declining',
    decisionTitle: 'Vote',
    decisionHint: 'The tally is informational. The plan changes only after the host confirms.',
    decisionEmpty: 'No votes yet.',
    decisionActivity: 'Activity to replace',
    decisionPickActivity: 'Choose an activity',
    decisionProposed: 'Replace with',
    decisionCreate: 'Start a vote',
    decisionProgress: '{cast} / {eligible} voted',
    decisionKeep: 'Keep the current plan',
    decisionAwaiting: 'Waiting for the host to confirm',
    decisionConfirmed: 'Confirmed',
    decisionVoted: 'Vote recorded',
    decisionNotEligible: 'You cannot vote until this traveler is linked to an account',
    decisionClose: 'Close voting',
    decisionConfirm: 'Confirm and update the plan',
    viewPublicJourney: 'View public journey',
    publicJourneyLink: 'Public journey',
    backToList: 'Back to list',
    applyNoteLabel: 'Application note',
    apply: 'Apply to join',
    withdrawApplication: 'Withdraw application',
    leave: 'Leave group trip',
    contactHost: 'Contact host',
    reserveSeat: 'Reserve seat',
    abandonQualification: 'Give up spot',
    confirmPayment: 'Confirm payment',
    completeJoin: 'Complete join',
    usePlatformWallet: 'Pay with platform wallet',
    confirmingPayment: 'Confirming payment…',
    paymentConfirmedJoining: 'Payment confirmed, completing join',
    approvedAwaitingPayment: 'Approved — awaiting payment (seat reserved).',
    approvedAwaitingPaymentNoSeat: 'Approved — awaiting payment (seat not reserved yet).',
    approvedParticipant: 'Approved as participant',
    joinedParticipant: 'Joined',
    paidJoined: 'Paid · joined group trip',
    paidCannotLeave: 'Paid seats cannot be left directly; full refund when host cancels.',
    cancelPaidParticipation: 'Cancel participation',
    cancelPaidConfirm: 'You will receive a full refund. Your seat is released only after refund completes.',
    buyerRefundProcessing: 'Refund in progress. Your seat stays occupied until refund completes.',
    buyerRefundedWithdrawn: 'Refunded · withdrawn from trip',
    buyerCancelAfterStart: 'The trip has started; paid self-cancel and refund are not available.',
    tripPhaseLabel: 'Trip phase: {phase}',
    tripPhase: {
      UPCOMING: 'Upcoming',
      IN_PROGRESS: 'In progress',
      COMPLETED: 'Completed',
      CANCELLING: 'Cancelling',
      CANCELLED: 'Cancelled',
    },
    pendingApplication: 'Application sent. Waiting for the host to confirm.',
    pendingApplicationHint: 'You join after the host confirms.',
    participantStatus: 'Current participation: {status}',
    noDirectChatHint: 'The host and joined companions can open group chat, or contact the host by message.',
    groupChat: 'Group chat',
    chatOpening: 'Opening…',
    chatUnavailable: 'Group chat is not ready yet. Try again shortly.',
    chatOpenFailed: 'Unable to open group chat',
    recruitmentClosedHint: 'Recruitment is closed; new TravelTrade cannot be created.',
    noSlotsHint: 'Approved seats are full. You can still apply; the host can review it if a seat opens later.',
    notFound: 'Group trip not found',
    applications: 'Applications',
    noApplications: 'No applications yet.',
    noticeApplicationUnavailable: 'That application could not be located. Showing all applications for this trip.',
    noParticipants: 'No companions yet.',
    partyHeading: 'Travel party',
    partySelf: 'Your name',
    partyCompanion: 'Companion name',
    addCompanion: 'Add companion',
    removeCompanion: 'Remove',
    partySize: '{count} people',
    requestedSeats: '{count} seats requested',
    travelersHeading: 'Travelers',
    guestLabel: 'No linked account',
    linkedLabel: 'Linked account',
    issueClaim: 'Create join link',
    claimTokenHint: 'Send this link to them. After they sign in, they join this existing place and do not take another seat.',
    claimAccept: 'Accept',
    claimAccepted: 'You joined this trip',
    noTravelers: 'No travelers yet.',
    participationHeading: 'Activity participation',
    participationHint: 'This changes only this activity. It does not leave the trip or change the number of places.',
    participationExpected: 'Expected',
    participationAway: 'Step away from this activity',
    participationEndAway: 'Return to this activity',
    participationSkipped: 'Skip this activity',
    participationAttended: 'Attended',
    participationClear: 'Expect them again',
    participationNotJoining: 'No longer on this trip',
    participationNotApplicable: 'This activity is cancelled',
    participationIndependent: 'Not joining · independent time',
    d1Heading: 'Independent time',
    d1IndependentActive: 'On independent time',
    d1ParticipationEnded: 'Group participation ended',
    d1Start: 'Start independent time',
    d1End: 'End independent time',
    d1EndParticipation: 'Confirm ending group participation',
    d1EndWarning: 'This does not leave the group, release a seat, or cancel a booking.',
    d1Cancel: 'Not now',
    participationReason: 'Note (optional)',
    noJourneyActivities: 'This trip has no activities yet.',
    applicant: 'Applicant {id}',
    member: 'Member {id}',
    approve: 'Approve',
    approveCapacityFullHint: 'Approved seats are full. Approve again after a seat opens.',
    reject: 'Reject',
    revokeApproval: 'Revoke approval',
    remove: 'Remove',
    openRecruitment: 'Open recruitment',
    closeRecruitment: 'Close recruitment',
    hostCancel: 'Cancel group trip',
    hostCancelling: 'Cancelling…',
    hostCancelled: 'Cancelled',
    cancellingHint: 'Cancellation in progress. Paid seats require full refund first.',
    cancelledHint: 'Cancelled',
    refundProcessing: 'Refund in progress. Paid members need full refund before completion.',
    paidRefundWarning: 'Paid members require full refund; retry if cancellation fails.',
    paidCannotRemove: 'Paid · cannot remove directly',
    recruitmentHint: 'Changing recruitment or companions does not process payment.',
    occupancyBase: '{cap} spots · {occupied} joined · {slots} remaining',
    occupancyFull: '{cap} spots · {occupied} joined · approved seats full',
    occupancyReserved: ' · {reserved} reserved · {commerce} remaining to join',
    defaultTitle: 'Group trip',
    loadFailed: 'Unable to load group trip',
    applyFailed: 'Unable to submit application',
    withdrawFailed: 'Unable to withdraw application',
    leaveFailed: 'Unable to leave group trip',
    payFailed: 'Unable to complete payment',
    joinFailed: 'Unable to complete join; retry without double charge',
    reserveFailed: 'Unable to reserve seat',
    createFailed: 'Unable to create group trip',
    createDraft: 'Create draft',
    creating: 'Creating…',
    createCapacityHint: 'Spot limit is how many people can join. The host does not take a spot.',
    hostVipBadge: 'Travel VIP',
    hostQuotaSummary: 'Active hosted group trips: {active}/{max}',
    invalidPublicationId: 'A valid public journey is required to create a group trip.',
    titleRequired: 'Recruitment title is required',
    recruitmentTitleLabel: 'Recruitment title',
    summaryLabel: 'Summary',
    capacityInvalid: 'Capacity must be at least 1',
    dateRangeInvalid: 'Enter valid start and end times',
    editTitle: 'Edit group trip draft',
    editHint: 'Edit draft recruitment details; start and end times are locked after creation.',
    editDraft: 'Edit draft',
    saveDraft: 'Save draft',
    saving: 'Saving…',
    updateFailed: 'Unable to update group trip',
    editOnlyDraftHint: 'This group trip is no longer a draft and cannot be edited.',
    backToDetail: 'Back to group trip',
    cancelEdit: 'Cancel',
    reloadAndRetry: 'Reload and try again',
    publicationIdLabel: 'Public journey',
    capacityLabel: 'Spots (host not counted)',
    startAtLabel: 'Start',
    dateConflict: {
      title: 'These dates overlap a group trip you are already confirmed on',
      body: 'You have already joined or are hosting another group trip during these dates, so you cannot join this one. To join this trip instead, first leave the other trip under its own rules.',
      openBody: 'You have already joined or are hosting another group trip during these dates, so recruitment cannot be opened.',
      viewTrip: 'View that trip',
      tripListLabel: 'Overlapping group trips',
      busy: 'Another join request is being processed. Please try again in a moment.',
      pendingTitle: 'Application sent',
      pendingBody: 'Note: you have another pending application whose dates overlap this trip. If one of them is approved first, you will not be able to join the other.',
      applicantConflict: 'This applicant is already confirmed on another group trip during these dates, so the application cannot be approved.',
    },
    endAtLabel: 'End',
    visibilityLabel: 'Visibility',
    discovery: {
      filtersLabel: 'Find group trips',
      filtersDescription: 'Filter public group trips by keyword, departure date, and availability.',
      keywordLabel: 'Keyword',
      keywordPlaceholder: 'Search title or summary',
      searchSubmit: 'Search',
      startFromLabel: 'Departure from',
      startToLabel: 'Departure until',
      startFromHint: 'Dates are the group trip departure time.',
      availableSlotsOnly: 'Available slots only',
      sortLabel: 'Sort',
      sortLatest: 'Latest published',
      sortStartAtAsc: 'Departing soon',
      clearFilters: 'Clear filters',
      loadingMore: 'Loading more…',
      filterRefreshing: 'Refreshing results…',
      noFilterResults: 'No group trips match your filters',
      noFilterResultsHint: 'Try different keywords, departure dates, or availability.',
      invalidDateRange: 'Departure from must be on or before departure until.',
      departureAt: 'Departs: {time}',
    },
  },
  grouptrip: {
    validation: { failed: 'Invalid request parameters.' },
    not: { found: 'Group trip not found.' },
    application: { not: { found: 'Application not found.' } },
    participant: { not: { found: 'Participant not found.' } },
    permission: { denied: 'You do not have permission for this action.' },
    capacity: { exceeded: 'Capacity is full.' },
    invalid: { lifecycle: 'This action is not allowed in the current state.' },
    concurrent: { modification: 'Data was updated by someone else; refresh and try again.' },
    date: {
      conflict: 'You are already confirmed on another group trip during these dates, so you cannot join.',
      conflict_other: 'This applicant is already confirmed on another group trip during these dates, so the application cannot be approved.',
      check_busy: 'Another join request is being processed. Please try again in a moment.',
    },
    dates: { locked: 'This journey is bound to a group trip, so its start and end dates, number of days and day dates are locked. Activities and times can still be changed.' },
    conversation: {
      not: { found: 'Group trip chat is not ready yet.' },
      permission: { denied: 'Only the host or a joined companion can open group chat.' },
    },
  },
  trade: {
    validation: { failed: 'Invalid trade request parameters.' },
    not: { found: 'Trade not found.' },
    permission: { denied: 'You do not have permission for this trade action.' },
    payment: {
      failed: 'Insufficient wallet balance. Please try again later.',
      platform_fee_destination_unavailable: 'Platform fee account is not ready; payment cannot complete.',
    },
    conflict: 'Unable to create or cancel the trade right now.',
    buyer_cancel: {
      not_allowed: 'This paid trade cannot be cancelled right now.',
      after_start: 'The trip has started or departed; paid self-cancel is not available.',
      after_release: 'Funds are releasing or released; cancellation refund is not available.',
    },
  },
  vip: {
    quota: { exceeded: 'Active hosted group trip limit reached (max {0}, current {1}).' },
    member: { identity: { unavailable: 'Member VIP identity is temporarily unavailable.' } },
    fee: {
      configuration: { invalid: 'VIP fee configuration is invalid; contact support.' },
      disclosureTitle: 'Platform fee (currently active)',
      platformFeeRate: 'Platform fee rate: {rate}',
      platformFeeRateVip: 'Platform fee rate: {rate} (VIP)',
      includedInDisplayPrice: 'The platform fee is included in the participant display price; buyers do not pay display price plus fee.',
      hostReceivableHint: 'For each paid participation, the host receivable is the display price minus the platform fee.',
      freeTripNoFee: 'Free group trips do not charge a platform fee.',
      disclosureLoadFailed: 'Unable to load platform fee disclosure.',
    },
  },
  review: {
    sectionTitle: 'Reviews',
    ratingLabel: 'Rating',
    contentPlaceholder: 'Share your travel experience (optional)',
    submitReview: 'Submit review',
    submitting: 'Submitting…',
    deleteReview: 'Delete review',
    confirmDelete: 'Are you sure you want to delete this review?',
    noReviews: 'No reviews yet.',
    loadMore: 'Load more reviews',
    averageRating: 'Avg {rating} stars',
    reviewCount: '{count} reviews',
    noRatingYet: 'No reviews yet',
    hostReputationLabel: 'Host rating',
    eligibleHint: 'The trip ended. You can leave a review.',
    audiencePublic: 'This is a public group trip: your review (rating, text and your public display name) will be shown publicly and anyone can see it. Your rating also counts toward the host\'s public average rating.',
    audienceFollowers: 'This group trip is for the host\'s followers: your review (rating, text and your public display name) follows this trip\'s follower audience, so only the host, fellow travelers and the host\'s followers can see it. Your rating also counts toward the host\'s public average rating.',
    audiencePrivate: 'This is a private group trip: your review (rating, text and your public display name) is visible only to this trip\'s host and fellow travelers. Your rating also counts toward the host\'s public average rating.',
    listUnavailable: 'Reviews for this group trip are not available right now.',
    alreadyReviewed: 'You have already left a review.',
    notEligible: 'You are not eligible to review this group trip.',
    loadFailed: 'Failed to load reviews',
    submitFailed: 'Failed to submit review',
    deleteFailed: 'Failed to delete review',
    eligibilityLoadFailed: 'Failed to load review eligibility',
    stars: (n) => '★'.repeat(n) + '☆'.repeat(5 - n),
    already_exists: 'You have already submitted a review.',
    deleted: 'Your previous review was deleted and cannot be resubmitted.',
    not_eligible: 'You are not eligible to review.',
    not_found: 'Review not found.',
    permission: { denied: 'You do not have permission to delete this review.' },
    validation: { failed: 'Invalid review request parameters.' },
    concurrent: { modification: 'Data was updated; please try again.' },
  },
  commerce: {
    currency: {
      unsupported: 'This currency is not supported for paid group trips',
    },
    earnings: {
      title: 'Earnings & trades',
      subtitle: 'Historical trade snapshots only. No withdrawal or settlement.',
      gross: 'Transaction volume',
      grossHint: 'Includes refunded trades. This is not realized host income.',
      platform_fee: 'Platform fee',
      host_receivable: 'Host receivable',
      pending_release: 'Pending release',
      released: 'Released',
      refunded: 'Refunded',
    },
    history: {
      title: 'Trade history',
      empty: 'No trades match the current filters.',
      loadFailed: 'Unable to load earnings and trades',
      filterGroupTrip: 'Group trip',
      filterGroupTripAll: 'All group trips',
      filterStatus: 'Status',
      filterStatusAll: 'All statuses',
      buyer: 'Buyer',
      buyerFallback: 'Traveler',
      gross: 'Gross',
      platform_fee: 'Platform fee',
      host_receivable: 'Host receivable',
      paidAt: 'Paid at',
      releasedAt: 'Released at',
      refundedAt: 'Refunded at',
      createdAt: 'Created at',
      status: {
        AWAITING_PAYMENT: 'Awaiting payment',
        PAID_PENDING_RELEASE: 'Pending release',
        RELEASED: 'Released',
        REFUNDED: 'Refunded',
        CANCELLED: 'Cancelled',
      },
    },
  },
  safety: {
    report: 'Report',
    block: 'Block',
    reportHost: 'Report host',
    blockHost: 'Block host',
    reportParticipant: 'Report participant',
    blockParticipant: 'Block participant',
    reportMember: 'Report member',
    reportPost: 'Report post',
    reportContent: 'Report content',
    reportGroupTrip: 'Report this group trip',
    reason: 'Reason',
    optionalNote: 'Optional details',
    submitReport: 'Submit report',
    submitting: 'Submitting…',
    cancel: 'Cancel',
    close: 'Close',
    reportSubmitted: 'Report submitted. We will review it.',
    reportFailed: 'Unable to submit report',
    blockConfirm: 'Block this member? This does not cancel the group trip or issue a refund.',
    confirmBlock: 'Confirm block',
    blocking: 'Blocking…',
    memberBlocked: 'Blocked',
    blockFailed: 'Unable to block',
    actionFailed: 'Safety action failed',
    authRequired: 'Sign in to report or block.',
    reasons: {
      SPAM: 'Spam',
      HARASSMENT: 'Harassment',
      HATE_OR_ABUSE: 'Hate or abuse',
      SEXUAL_CONTENT: 'Sexual content',
      VIOLENCE: 'Violence',
      SCAM_OR_FRAUD: 'Scam or fraud',
      IMPERSONATION: 'Impersonation',
      PRIVACY: 'Privacy',
      MISINFORMATION: 'Misinformation',
      OTHER: 'Other',
    },
  },
  social: {
    safety: {
      block: {
        self: { not: { allowed: 'You cannot block yourself' } },
        relationship: { conflict: 'Block state conflict; try again' },
      },
      report: {
        self: { not: { allowed: 'You cannot report yourself' } },
        target: { not: { found: 'Report target not found' } },
        invalid: { reason: 'Invalid report reason' },
        idempotency: { conflict: 'Report request conflict; try again' },
      },
      validation: { failed: 'Invalid safety request' },
    },
  },
};

export const travelZhCN = {
  discover: {
    title: '探索',
    subtitle: '浏览公开的旅游故事与行程，再决定要追踪或收藏。',
    compose: '发布贴文',
    tabsLabel: '探索分页',
    railLabel: '探索信息',
    railTitle: '故事与行程怎么连在一起',
    railHint: '贴文常连结公开行程；行程页可看路线与安排，再回探索继续逛。',
    firstUse: {
      guestLead: '第一次来？可以这样开始：',
      guestPost: '在「推荐」阅读公开旅游故事',
      guestJourney: '在「行程」或右侧入口查看公开行程',
      guestLogin: '按赞、收藏、追踪与发布需先登录',
    },
    tabs: {
      forYou: '推荐',
      journeys: '行程',
      social: '贴文',
    },
    kinds: {
      ALL: '全部',
      MOOD: '心情',
      JOURNEY: '旅程',
      JOURNEY_INVITATION: '旅程邀请',
      PLACE: '地点',
      FOOD: '美食',
    },
    posts: {
      viewLabel: '贴文检视',
      list: '清单',
      map: '地图',
      location: '地点',
      kind: '类型',
      allLocations: '全部地点',
      following: '追踪中',
      followingHint: '只看你追踪的人',
      showOnMap: '在地图查看',
      filtersLabel: '贴文筛选',
      publicJourney: '公开行程',
      openPublishedJourney: '查看已发布的行程与地图',
      journeyUnavailable: '旅程目前无法显示',
    },
    locationSelector: {
      root: '全部地点',
      selectedPrefix: '已选：',
      back: '返回',
      clear: '清除地点',
      loading: '加载地点中…',
      loadFailed: '无法加载地点。',
      use: '使用此地点',
      selected: '已选取',
      openChildren: '查看下层',
      empty: '此层级没有地点。',
    },
    loading: '加载中…',
    end: '已显示全部内容。',
    notInterested: '不感兴趣',
    mute: '静音创作者',
    hideContent: '隐藏此内容',
    days: '天',
    viewJourney: '查看行程',
    contentType: {
      journey: '公开行程',
      socialPost: '旅游故事',
    },
    empty: {
      title: '暂无内容',
      hint: '稍后再来查看个性化推荐。',
      guestHint: '目前还没有可推荐的内容。你可以先逛公开行程，或登录后再回来看看。',
    },
    error: {
      title: '无法加载',
      loadFailed: '无法加载行程。',
      postsLoadFailed: '无法加载贴文。',
      actionFailed: '操作失败，请重试。',
    },
    journeys: {
      emptyTitle: '未找到符合的行程',
      emptyHint: '试着调整筛选条件。',
      emptyWithQuery: '未找到符合「{q}」的行程，可换关键词或清除搜索。',
    },
    filters: {
      label: '行程筛选',
      location: '地点',
      allLocations: '全部地点',
      clearLocation: '清除地点',
      selectedLocation: '已选地点',
      budgetMin: '最低预算',
      budgetMax: '最高预算',
      currency: '货币',
      minDays: '最少天数',
      maxDays: '最多天数',
      sort: '排序',
      apply: '应用',
      reset: '重置',
    },
    search: {
      label: '搜索行程',
      placeholder: '东京、镰仓、Tokyo…',
      submit: '搜索',
      clear: '清除',
      context: '正在搜索「{q}」',
    },
    suggestions: {
      loading: '建议加载中…',
      empty: '没有建议，可按 Enter 搜索。',
      error: '建议暂时不可用，仍可按 Enter 搜索。',
      type: {
        geo: '地点',
        journey: '行程',
      },
    },
    sort: {
      latest: '最新',
      hot: '热门',
    },
  },
  nav: {
    brand: 'Formosa Travel',
    explore: '探索',
    journeys: '行程',
    groupTripDiscover: '组团',
    me: '我的',
    primary: '主要导航',
    primaryMobile: '行动主要导航',
    notificationCenter: '通知中心',
    saved: '我的收藏',
    messages: '消息',
    myJourneys: '我的行程',
    findGroupTrips: '找组团',
    groupTrips: '我的组团',
    earnings: '收益与交易',
    invitations: '旅程邀请',
    notices: '跟团通知',
    notifications: '通知',
    publicGroupTrips: '公开组团',
    more: '更多',
    profile: '我的创作者页面',
    signIn: '登录',
    signOut: '退出',
    register: '注册',
    signInRegister: '登录 / 注册',
    checkingSession: '正在确认登录状态…',
    member: '会员',
    language: '语言',
  },
  auth: {
    googleContinue: '使用 Google 继续',
    googleConnecting: '连接中…',
    googleUnavailable: '目前无法使用 Google 继续（缺少设定）。',
  },
  places: {
    searchLabel: '搜索地点',
    searchPlaceholder: '输入地点名称',
    resolving: '正在确认地点',
    searching: '搜索中…',
    loadingProvider: '正在加载地点搜索…',
    candidatesLabel: '地点候选',
  },
  direct: {
    errors: {
      unavailable: '目前无法向这位旅人发送消息。',
      privacyDenied: '对方目前不接受新的私信。',
      chatDisabled: '目前暂时无法建立新的对话，请稍后再试。',
      accountCannotUse: '目前的账号无法使用私信。',
      peerNotFound: '找不到这位旅人。',
      authExpired: '登录已过期，请重新登录后再试。',
      network: '网络暂时无法连线，请稍后再试。',
      startFailed: '无法开始对话，请稍后再试。',
    },
  },

  discoverGuest: {
    title: '登录后继续探索',
    body: '按赞、收藏、留言、追踪与地图探索需要登录。你仍可先在「推荐」阅读公开故事。',
    followingTitle: '登录后查看追踪动态',
    followingBody: '「追踪中」会显示你追踪的旅人最新贴文。登录后会回到这个分页。',
    mapTitle: '登录后探索旅游地图',
    mapBody: '地图探索需要登录。登录后会回到此分页；你也可以先回「推荐」继续浏览公开内容。',
    socialTitle: '登录后浏览贴文探索',
    socialBody: '此贴文探索检视需要登录。你仍可先在「推荐」阅读公开故事与公开行程。',
    cta: '登录以继续',
    browseForYou: '先回推荐浏览',
    footnote: '登录后会回到你刚才想去的页面。',
    engagementNotice: '登录后即可按赞、收藏或留言，并回到目前页面。',
  },
  journeyWorkspace: {
    overviewHint: '设定这趟去哪、哪几天，以及行程的基本信息。',
    planningHint: '安排每天要做什么、时间与地点。',
  },
  journeyCost: {
    disclaimer: '此功能仅协助记账与分摊，不代表平台已代为付款。',
    actions: {
      refresh: '重新整理',
      cancel: '取消',
      confirm: '确认',
      saving: '储存中…',
      reloadBudget: '重新载入最新预算',
    },
    budget: {
      total: '总预算',
      spent: '已记支出',
      remaining: '剩余额度',
      currency: '币别',
      allocated: '已分配',
      unallocated: '未分配',
      baseCurrencyHint: '基准币别 · 单一行程',
      allocatedHint: '分类额度合计',
      unallocatedHint: '总预算 − 已分配',
      actualOnExpenses: '实际已记支出请至「支出」查看；本页仅显示预算分配。',
      openExpenses: '开启支出',
      edit: '编辑预算',
      create: '建立预算',
      save: '储存预算',
      categoryLegend: '类别分配',
      allocatedPreview: '已分配预览',
      unallocatedPreview: '未分配预览',
      openFailed: '无法开启预算',
      validation: '请检查预算数值。',
      forbidden: '你没有权限变更此预算。',
      lifecycle: '目前行程状态无法变更预算。',
      alreadyExists: '预算已存在，请重新载入后编辑。',
      readonlyRole: '只读：仅拥有者或协调者可变更预算。',
      readonlyLifecycle: '只读：目前行程状态无法变更预算。',
      confirmCreateTitle: '确认建立预算？',
      confirmReplaceTitle: '确认更新预算？',
      confirmCreateBody: '将以你输入的数值设定旅行预算。',
      confirmReplaceBody: '这会完整取代预算与类别分配。',
      emptyTitle: '尚未设定旅行预算',
      setup: '设定预算',
      conflict: '预算已被其他操作更新。请重新载入最新预算。',
      currencyMismatch: '预算币别需与行程币别一致',
      validationErrors: {
        currencyRequired: '请选择币别（ISO 4217）。',
        baselineInvalid: '总预算必须是有效且不为负数的金额。',
        baselineNegative: '总预算不可为负数。',
        categoriesRequired: '至少需要一个类别分配。',
        categoryUnknown: '未知的类别：{category}',
        categoryAmountInvalid: '{category}的金额无效。',
        categoryAmountNegative: '{category}的金额不可为负数。',
        allocationExceedsTotal: '类别分配合计不可超过总预算。',
      },
    },
    categories: {
      ACCOMMODATION: '住宿',
      TRANSPORT: '交通',
      FOOD: '餐饮',
      TICKET: '票券',
      SHOPPING: '购物',
      INSURANCE: '保险',
      COMMUNICATION: '通讯',
      OTHER: '其他',
    },
    expense: {
      statusAll: '全部',
      statusActive: '进行中',
      statusVoided: '已作废',
      splitPreview: '分摊预览（最终以服务器结果为准）',
    },
    split: {
      settlementTitle: '结算建议（仅供参考）',
      settlementCopy: '以下建议协助成员自行结算，平台不会代收、代付或标记结算状态。',
      confirmNotPayment: '请确认你了解：这不是付款流程。',
      statusCurrent: '最新',
      statusOutdated: '已过期',
      statusEmpty: '尚未计算',
    },
  },
  common: {
    travel: 'Travel',
    loading: '加载中…',
    retry: '重试',
    loadMore: '加载更多',
    loadFailed: '加载失败',
    actionFailed: '操作失败，请稍后再试。',
    empty: '目前没有数据',
    back: '返回',
    cancel: '取消',
    read: '已读',
    host: '主揪',
    participants: '旅伴',
    apiError: {
      network: {
        title: '网络连接失败',
        description: '请确认连接后再试一次。',
      },
      unauthorized: {
        title: '登录状态失效',
        description: '请重新登录后再继续。',
      },
      forbidden: {
        title: '没有权限',
        description: '你目前无法执行此操作。',
      },
      notFound: {
        title: '找不到内容',
        description: '指定的内容不存在或已移除。',
      },
      validation: {
        title: '资料有误',
        description: '请检查输入内容后再试。',
      },
      conflict: {
        title: '资料已更新',
        description: '请重新整理后再试一次。',
      },
      rateLimited: {
        title: '操作过于频繁',
        description: '请稍后再试。',
      },
      unavailable: {
        title: '服务暂时无法使用',
        description: '请稍后再试一次。',
      },
      server: {
        title: '服务暂时发生问题',
        description: '请稍后再试一次。',
      },
      domain: {
        title: '无法完成操作',
        description: '请稍后再试。',
      },
      unknown: {
        title: '发生错误',
        description: '请稍后再试一次。',
      },
    },
  },
  groupTripNotice: {
    title: '跟团通知',
    types: {
      APPLICATION_RECEIVED: '新的参加申请',
      APPLICATION_APPROVED: '参加成功',
      APPLICATION_REJECTED: '申请结果',
      APPLICATION_WITHDRAWN: '申请已撤回',
      PARTICIPANT_REMOVED: '参与资格变更',
      PARTICIPANT_LEFT: '成员退出',
      GROUP_TRIP_CANCELLED: '跟团已取消',
      GROUP_TRIP_STARTING_SOON: '即将出发',
      UNKNOWN: '跟团通知',
    },
    messages: {
      APPLICATION_RECEIVED: '你的跟团收到新的参加申请',
      APPLICATION_APPROVED: '你已成功加入这个跟团',
      APPLICATION_REJECTED: '你的参加申请未通过',
      APPLICATION_WITHDRAWN: '一笔参加申请已撤回',
      PARTICIPANT_REMOVED: '你已被移出这个跟团',
      PARTICIPANT_LEFT: '有成员退出了这个跟团',
      GROUP_TRIP_CANCELLED: '这个跟团已取消',
      GROUP_TRIP_STARTING_SOON: '这个跟团即将出发，记得确认集合与行程信息',
    },
    unread: '未读',
    markRead: '标为已读',
    markAll: '全部标为已读',
    markAllDone: '已全部标为已读',
    empty: '目前没有跟团通知',
    emptyDescription: '有新的申请或行程变动时，会显示在这里。',
    lead: '追踪跟团申请与行程变动。',
    error: '无法加载跟团通知',
    actionFailed: '操作失败，请重试',
    loadMore: '加载更多通知',
    openTrip: '查看组团',
  },
  notificationCenter: {
    relatedAria: '其他通知入口',
    relatedLabel: '其他入口',
    announcements: '公告',
    siteMail: '站内信',
  },
  socialNotification: {
    title: '通知',
    bell: '通知',
    someone: '有人',
    unread: '未读',
    markRead: '标为已读',
    markAll: '全部标为已读',
    markAllDone: '已全部标为已读',
    empty: '目前没有通知',
    emptyDescription: '有人关注、点赞或留言时，会显示在这里。',
    lead: '查看社群互动与最新动态。',
    error: '无法加载通知',
    actionFailed: '操作失败，请重试',
    loadMore: '加载更多通知',
    types: {
      SOCIAL_FOLLOW: '{actor} 关注了你',
      SOCIAL_POST_LIKE: '{actor} 赞了你的帖子',
      SOCIAL_POST_COMMENT: '{actor} 评论了你的帖子',
      SOCIAL_COMMENT_REPLY: '{actor} 回复了你的评论',
      UNKNOWN: '你有一则新通知',
    },
    badge: {
      count: '{count} 个未读通知',
      atLeast: '至少 {count} 个未读通知',
      hasUnread: '有未读通知',
    },
  },
  savedJourneys: {
    title: '收藏行程',
    subtitle: '您收藏供稍后查看的公开行程（不含社群贴文收藏）。',
    loading: '加载收藏行程…',
    loadFailedTitle: '无法加载收藏行程',
    emptyTitle: '尚未收藏任何公开行程',
    emptyHint: '在公开行程页点击收藏后，会显示在这里。',
    explore: '探索',
    savedAt: '收藏于 {time}',
  },
  saved: {
    title: '我的收藏',
    subtitle: '您收藏的贴文与公开行程，依收藏时间排序。',
    filterLabel: '收藏类型',
    filterAll: '全部',
    filterPosts: '贴文',
    filterJourneys: '行程',
    loading: '加载收藏…',
    loadFailedTitle: '无法加载收藏',
    emptyAllTitle: '尚未收藏任何内容',
    emptyAllHint: '在贴文或公开行程页点击收藏后，会显示在这里。',
    emptyPostsTitle: '尚未收藏任何贴文',
    emptyPostsHint: '在社群贴文页点击收藏后，会显示在这里。',
    emptyJourneysTitle: '尚未收藏任何公开行程',
    emptyJourneysHint: '在公开行程页点击收藏后，会显示在这里。想开始规划时，可到公开行程页复制，或建立全新行程。',
    explore: '探索',
    createBlankJourney: '建立全新行程',
    journeyNextStepsLabel: '收藏行程的下一步',
    journeyNextStepsHint: '收藏只是先记下来。要开始规划请到公开行程页复制；若要从头规划，可建立全新行程。',
    viewPublicJourney: '查看公开行程',
    startPlanningViaCopy: '复制并开始规划',
    cardActionsLabel: '行程下一步',
    savedAt: '收藏于 {time}',
    typePost: '贴文',
    typeJourney: '行程',
    defaultPostTitle: '已收藏贴文',
    defaultJourneyTitle: '已收藏行程',
  },
  publicJourney: {
    loading: '加载行程中…',
    unavailable: '行程不可用',
    unavailableHint: '此行程可能不存在，或已不再公开。',
    loadFailedTitle: '无法加载此行程',
    tryAgain: '再试一次',
    backToExplore: '返回探索',
    publicItinerary: '公开行程',
    itineraryLoadFailed: '无法加载行程内容。',
    createGroupTrip: '创建组团',
    publicGroupTrips: '公开组团',
    sharedBy: '分享者',
    travelerFallback: '旅人',
    dayCount: '{count} 天',
    activityCount: '{count} 项安排',
    publishedRoute: '已发布路线',
    itinerary: '行程',
    itineraryUnavailableTitle: '公开行程内容暂不可用',
    itineraryUnavailableHint: '目前还没有可显示的行程内容。',
    mappedStops: '{count} 个地图标记',
    dayHeading: '第 {number} 天',
    noMapPin: '无地图标记',
    unscheduled: '未排程',
    noMappedLocation: '尚无地图位置',
    timelineEyebrow: '旅程路线',
    timelineTitle: '旅程时间轴',
    sharedActivities: '{count} 则分享安排',
    timelineLoading: '加载路线中…',
    timelineUnavailable: '时间轴暂不可用',
    timelineRetry: '再试一次时间轴',
    timelineEmptyTitle: '目前还没有公开安排',
    timelineEmptyHint: '尚未分享公开活动或回忆。',
    journeyMemory: '旅程回忆',
    loadMore: '加载更多',
    loadingMore: '加载中…',
    engagementLoadFailed: '无法加载你的互动状态，请再试一次。',
    likeFailed: '无法更新按赞，请再试一次。',
    saveFailed: '无法更新收藏，请再试一次。',
    like: '按赞旅程',
    unlike: '取消按赞',
    save: '收藏旅程',
    unsave: '取消收藏',
    coverAlt: '{title} 的封面',
    actionGuideTitle: '想怎么使用这趟行程？',
    actionGuideSave: '收藏：先记下来，之后可从「我的收藏」回来查看。',
    actionGuideCopy: '复制：建立一份你可编辑的行程，并进入规划。',
    copyCta: '复制为我的行程',
    copyBusy: '复制中…',
    copyHint: '复制不会取得原行程的编辑权；成功后会前往你的规划页。',
    copySuccess: '已复制为你的行程，正在前往规划',
    copyFailed: '目前无法复制此行程，请稍后再试。',
    copyUnavailable: '此行程目前不开放复制。',
    copyIntentFocus: '请确认下方「复制为我的行程」以开始规划。',
  },
  copy: {
    source: {
      not: {
        available: '此行程目前無法查看',
      },
    },
    not: {
      allowed: '此行程目前無法複製',
    },
    disabled: '此行程不開放複製',
    validation: {
      failed: '請求參數不正確，請再試一次。',
    },
    idempotency: {
      conflict: '此次複製與先前請求衝突，請重新操作。',
    },
  },
  followingFeed: {
    brand: '旅游社群',
    title: '追踪中',
    compose: '发布贴文',
    subtitle: '你追踪的旅人所发布的贴文。',
    loading: '加载追踪动态…',
    errorTitle: '无法加载追踪动态',
    retry: '重新整理',
    emptyTitle: '尚未看到追踪中的新贴文',
    emptyHint: '可以前往探索找到感兴趣的旅人或内容。',
    emptyCta: '前往探索',
    railLabel: '追踪动态说明',
    railTitle: '只看你追踪的人',
    railHint: '这里会显示你追踪的旅人的新贴文。还没有内容时，可以前往探索开始追踪。',
    explore: '探索',
    loadMore: '加载更多',
    loadingMore: '加载中…',
    retryMore: '重试',
  },
  creator: {
    loading: '加载旅人页面…',
    unavailableTitle: '找不到这位旅人',
    unavailableHint: '此页面可能不存在，或目前无法查看。',
    backToExplore: '返回探索',
    loadFailedTitle: '无法加载此旅人',
    tryAgain: '再试一次',
    eyebrow: '旅人',
    follow: '追踪',
    following: '已追踪',
    updating: '更新中…',
    followFailed: '目前无法追踪，请再试一次。',
    unfollowFailed: '目前无法取消追踪，请再试一次。',
    tabsLabel: '旅人内容',
    postsTab: '贴文',
    journeysTab: '行程',
    loadingPosts: '加载贴文…',
    loadingJourneys: '加载行程…',
    postsLoadFailed: '无法加载贴文',
    journeysLoadFailed: '无法加载行程',
    emptyPostsTitle: '还没有公开贴文',
    emptyPostsHint: '这位旅人尚未发布公开贴文。',
    emptyOwnPostsHint: '发布第一则旅游故事，开始你的旅人页面。',
    emptyJourneysTitle: '还没有公开行程',
    emptyJourneysHint: '这位旅人尚未分享公开行程。',
    loadMorePosts: '加载更多贴文',
    loadMoreJourneys: '加载更多行程',
    loadingMore: '加载中…',
    end: '已显示全部内容。',
    publicItinerary: '公开行程',
    dayActivityCount: '{days} 天 · {activities} 项安排',
    coverAlt: '{title} 的封面',
    quotedUnavailable: '引用的贴文目前无法查看',
    quotedFallback: '查看引用贴文',
    profileLoadFailed: '无法加载旅人页面。',
    contentLoadFailed: '无法加载内容。',
    followersMetric: '追踪者',
    followingMetric: '追踪中',
    postsMetric: '贴文',
    journeysMetric: '行程',
    followersCountAria: '{name} 的追踪者 {count} 人',
    followingCountAria: '{name} 追踪中 {count} 人',
    followersTitle: '追踪者',
    followingPeopleTitle: '追踪中',
    followersEmptyTitle: '还没有追踪者',
    followersEmptyHint: '当有人追踪这位旅人时，会显示在这里。',
    followingPeopleEmptyTitle: '还没有追踪任何人',
    followingPeopleEmptyHint: '这位旅人追踪的对象会显示在这里。',
    connectionsLoading: '加载名单…',
    connectionsLoadFailedTitle: '无法加载名单',
    connectionsLoadFailed: '目前无法加载名单，请再试一次。',
    openCreatorProfile: '查看旅人页面',
    editProfile: '编辑个人资料',
    editTitle: '编辑个人资料',
    editLead: '可修改昵称与头像。保存后会更新你的旅人页面与账号显示名称。',
    closeEdit: '关闭编辑',
    nicknameLabel: '昵称',
    nicknameHint: '最多 50 字，可留空。',
    nicknameTooLong: '昵称不可超过 50 字。',
    avatarUpload: '上传头像',
    avatarUploading: '上传中…',
    avatarRemove: '移除头像',
    avatarUploadFailed: '头像上传失败，请再试一次。',
    saveProfile: '保存',
    saving: '保存中…',
    profileSaved: '个人资料已更新。',
    profileSaveFailed: '无法保存个人资料，请再试一次。',
    discardTitle: '舍弃未保存的修改？',
    discardBody: '你有尚未保存的变更。离开后这些修改会遗失。',
    discardConfirm: '舍弃修改',
  },
  groupTrip: {
    publicRecruitment: '公开招募',
    myGroupTrips: '我的组团',
    createTitle: '创建组团',
    publicListTitle: '公开组团',
    publicListHint: '显示正在招募、所有人都可以看到的组团。追踪者可见的组团请透过分享连结开启。',
    noPublicRecruitment: '目前没有公开招募。',
    hostEmptyList: '你还没有组团。可以先选一个已发布的公开行程来发起。',
    notVisibleTitle: '组团不可见',
    notVisibleHint: '可能不存在、尚未公开，或公开行程已不可读。',
    backToPublicList: '返回公开招募',
    hostManageLink: '前往 Host 管理',
    runtimeTimelineTitle: '旅途记录',
    runtimePlannedTitle: '出发时的计划',
    runtimeChangedTitle: '旅途中的变更',
    runtimeEmpty: '这趟还没有旅途记录。',
    runtimeAdded: '旅途中新增',
    runtimeCancelled: '取消了活动',
    runtimeReplaced: '换成了另一个活动',
    runtimeTimeChanged: '调整了时间',
    runtimeParticipation: '参加状态有变更',
    lateJoinTitle: '途中加入',
    lateJoinEntryBody: '这趟组团已经在旅途中。你可以为自己提出加入，等主办人决定。提出后不会先保留名额，也不代表一定能加入。',
    lateJoinRequest: '提出加入',
    lateJoinRequesting: '提出中',
    lateJoinEmptyTitle: '还没有纪录',
    lateJoinEmptyBody: '你还没有提出过途中加入。',
    lateJoinPendingBody: '等待主办人决定',
    lateJoinPendingCapacity: '这是现在的人数，不代表已为你保留。',
    lateJoinStatusPending: '待决定',
    lateJoinStatusApproved: '已加入',
    lateJoinStatusRejected: '未同意',
    lateJoinStatusCancelled: '已取消',
    lateJoinCancelAction: '取消这次请求',
    lateJoinCancelTitle: '取消这次请求？',
    lateJoinCancelBody: '取消后这笔会留在纪录里，状态变成已取消。之后若仍符合条件，可以再提出。',
    lateJoinCancelConfirm: '确认取消',
    lateJoinNotYet: '先不要',
    lateJoinCancelledBody: '这次请求已取消。纪录会留下来。画面不猜是谁取消。',
    lateJoinRejectedBody: '主办人没有同意。你还没有加入这趟组团，人数也没有因此改变。',
    lateJoinApprovedBody: '你已在旅途中加入。',
    lateJoinJoinAt: '加入时间 {when}',
    lateJoinResubmit: '再提出一次',
    lateJoinSamePending: '你已经有一笔等待决定的请求。再送一次不会多一张卡片。',
    lateJoinHostCapacity: '这是现在的人数。送出同意时才会再确认，不保证一定成功。',
    lateJoinHostCount: '目前 {occupied} / {capacity} 位。',
    lateJoinHostEmpty: '目前没有待决定的请求。',
    lateJoinApprove: '同意加入',
    lateJoinReject: '拒绝',
    lateJoinRejectMeaning: '拒绝是不让对方加入，和取消这笔请求不同。',
    lateJoinHostCancel: '取消这笔请求',
    lateJoinApproveTitle: '同意加入？',
    lateJoinApproveBody: '会成为这趟的同行者。不会收款、不会改订位，也不会变成行程协作者。',
    lateJoinBack: '返回',
    lateJoinRejectTitle: '拒绝这次加入？',
    lateJoinRejectBody: '不会建立同行者，人数也不会改变。对方之后仍可再提出。',
    lateJoinHostCancelTitle: '取消这笔请求？',
    lateJoinHostCancelBody: '这不是拒绝。请求会留在纪录里，状态变成已取消。',
    lateJoinCapacityFullTitle: '这次没有完成',
    lateJoinCapacityFullBody: '目前名额不足，请求仍在待决定。',
    lateJoinTravelerContext: '旅途中加入 · 加入时间 {when}。时间由系统在同意时写入，不能改。',
    lateJoinNotJoinedYet: '加入之前',
    lateJoinTimelineRequested: '提出途中加入',
    lateJoinTimelineCancelledByRequester: '提出的人取消了途中加入请求',
    lateJoinTimelineCancelledByHost: '主办人取消了途中加入请求',
    lateJoinTimelineRejected: '主办人没有同意途中加入',
    lateJoinTimelineJoined: '在旅途中加入',
    lateJoinErrorNotTraveling: '这趟还没有在旅途中，不能提出途中加入。',
    lateJoinErrorAlreadyTraveler: '你已经在这趟组团里。',
    lateJoinErrorRejoin: '离开或被移出后，不能用途中加入再回来。',
    lateJoinErrorHostCannotRequest: '主办人不能对自己的组团提出途中加入。',
    lateJoinErrorNotPending: '这笔已经结束，不能再做这个动作。',
    lateJoinErrorApprovedWithoutTraveler: '暂时无法显示，请再试一次。',
    lateJoinErrorNotHost: '只有主办人可以处理这笔请求。',
    lateJoinLoading: '读取中',
    lateJoinLoadError: '目前无法载入，请再试一次。',
    lateJoinRetry: '再试一次',
    lateJoinCancelling: '取消中',
    lateJoinApproving: '同意中',
    lateJoinRejecting: '拒绝中',
    decisionTitle: '投票',
    decisionHint: '投票结果只供参考。行程要等主揪确认后才会变更。',
    decisionEmpty: '目前没有投票。',
    decisionActivity: '要更换的活动',
    decisionPickActivity: '请选择活动',
    decisionProposed: '建议换成',
    decisionCreate: '发起投票',
    decisionProgress: '{cast} / {eligible} 已投票',
    decisionKeep: '维持原案',
    decisionAwaiting: '等待主揪确认',
    decisionConfirmed: '已确认',
    decisionVoted: '已投票',
    decisionNotEligible: '不可投票，尚未绑定账号',
    decisionClose: '结束投票',
    decisionConfirm: '确认并更新行程',
    viewPublicJourney: '查看公开行程',
    publicJourneyLink: '公开行程',
    backToList: '返回列表',
    applyNoteLabel: '申请备注',
    apply: '申请加入',
    withdrawApplication: '撤回申请',
    leave: '离开组团',
    contactHost: '联系 Host',
    reserveSeat: '保留名额',
    abandonQualification: '放弃资格',
    confirmPayment: '确认付款',
    completeJoin: '完成加入',
    usePlatformWallet: '使用平台钱包付款',
    confirmingPayment: '正在确认付款…',
    paymentConfirmedJoining: '付款已确认，正在完成加入',
    approvedAwaitingPayment: '已核准 — 等待付款（名额已预留）。',
    approvedAwaitingPaymentNoSeat: '已核准 — 等待付款（尚未 Participant／尚未保留名额）。',
    approvedParticipant: '已核准为 Participant',
    joinedParticipant: '已加入',
    paidJoined: '已付款 · 已加入组团',
    paidCannotLeave: '已付款席位不可自行离开；Host 取消组团时才会全额退款。',
    cancelPaidParticipation: '取消参加',
    cancelPaidConfirm: '取消后将退回本次付款全额。退款完成后名额才会释出。',
    buyerRefundProcessing: '退款处理中。完成后名额才会释出。',
    buyerRefundedWithdrawn: '已退款 · 已退出参加',
    buyerCancelAfterStart: '行程已开始，无法自行取消并退款。',
    tripPhaseLabel: '行程状态：{phase}',
    tripPhase: {
      UPCOMING: '即将出发',
      IN_PROGRESS: '进行中',
      COMPLETED: '已结束',
      CANCELLING: '取消处理中',
      CANCELLED: '已取消',
    },
    pendingApplication: '申请已送出，等待主揪确认。',
    pendingApplicationHint: '主揪确认后才会正式加入。',
    participantStatus: '目前参加状态：{status}',
    noDirectChatHint: '主揪与已加入的旅伴可开启组团群聊；也可透过私讯联络主揪。',
    groupChat: '群组聊天',
    chatOpening: '开启中…',
    chatUnavailable: '群组聊天尚未就绪，请稍后再试。',
    chatOpenFailed: '无法开启群组聊天',
    recruitmentClosedHint: '招募已关闭，无法再建立新的 TravelTrade。',
    noSlotsHint: '目前核准名额已满，仍可送出申请；若之后有名额，主揪可再处理你的申请。',
    notFound: '找不到组团',
    applications: '申请',
    noApplications: '尚无申请。',
    noticeApplicationUnavailable: '通知中的申请目前无法定位，已显示此组团全部申请。',
    noParticipants: '尚无旅伴。',
    partyHeading: '同行者',
    partySelf: '本人姓名',
    partyCompanion: '同行者姓名',
    addCompanion: '新增同行者',
    removeCompanion: '移除',
    partySize: '共 {count} 人',
    requestedSeats: '需要 {count} 个名额',
    travelersHeading: '出游名单',
    guestLabel: '尚未绑定账号',
    linkedLabel: '已绑定账号',
    issueClaim: '发出加入链接',
    claimTokenHint: '请把这组链接交给对方。对方登录后即可加入，不会再占新的名额。',
    claimAccept: '接受加入',
    claimAccepted: '已加入这趟组团',
    noTravelers: '尚无出游名单。',
    participationHeading: '活动参加',
    participationHint: '这只改变这个活动的参加状态，不会退出组团，也不会改变名额。',
    participationExpected: '预期参加',
    participationAway: '暂时离开此活动',
    participationEndAway: '回到此活动',
    participationSkipped: '跳过此活动',
    participationAttended: '已参加',
    participationClear: '恢复预期参加',
    participationNotJoining: '已不在这趟组团',
    participationNotApplicable: '此活动已取消',
    participationIndependent: '不参加 · 独立时段',
    d1Heading: '独立行动',
    d1IndependentActive: '独立行动中',
    d1ParticipationEnded: '已结束团体参与',
    d1Start: '开始独立行动',
    d1End: '结束独立行动',
    d1EndParticipation: '确认结束团体参与',
    d1EndWarning: '不会退出组团、不会释出名额，也不会自动取消订位。',
    d1Cancel: '先不要',
    participationReason: '备注（选填）',
    noJourneyActivities: '这趟行程还没有活动。',
    applicant: '申请人 {id}',
    member: '成员 {id}',
    approve: '核准',
    approveCapacityFullHint: '目前核准名额已满，需有空出名额后才能核准。',
    reject: '拒绝',
    revokeApproval: '撤销核准',
    remove: '移除',
    openRecruitment: '开启招募',
    closeRecruitment: '关闭招募',
    hostCancel: '取消组团',
    hostCancelling: '取消处理中',
    hostCancelled: '已取消',
    cancellingHint: '取消处理中。已付款席位需全额退款后才会完成取消。',
    cancelledHint: '已取消',
    refundProcessing: '退款处理中。已付款成员需全额退款；最终取消会在退款完成后生效。',
    paidRefundWarning: '已付款成员需全额退款；取消失败或中断时可再试。',
    paidCannotRemove: '已付款 · 不可直接移除',
    recruitmentHint: '调整招募与旅伴名单不会处理付款。',
    occupancyBase: '名额 {cap} 人 · 目前参加 {occupied} 人 · 尚可接受 {slots} 人',
    occupancyFull: '名额 {cap} 人 · 目前参加 {occupied} 人 · 核准名额已满',
    occupancyReserved: ' · 已预留 {reserved} 人 · 剩余可加入 {commerce} 人',
    defaultTitle: 'Group trip',
    loadFailed: '无法加载组团',
    applyFailed: '无法送出申请',
    withdrawFailed: '无法撤回申请',
    leaveFailed: '无法离开组团',
    payFailed: '无法完成付款',
    joinFailed: '无法完成加入，请重试（不会重复扣款）',
    reserveFailed: '无法保留名额',
    createFailed: '无法创建组团',
    createDraft: '创建草稿',
    creating: '创建中…',
    createCapacityHint: '名额是可加入人数上限；主揪不占名额，也不需替自己送出申请。',
    hostVipBadge: 'Travel VIP',
    hostQuotaSummary: '进行中的组团：{active}/{max}',
    invalidPublicationId: '需要有效的公开旅程才能创建组团。',
    titleRequired: '请填招募标题',
    recruitmentTitleLabel: '招募标题',
    summaryLabel: '摘要',
    capacityInvalid: '参加名额至少为 1',
    dateRangeInvalid: '请填正确的开始／结束时间',
    editTitle: '编辑组团草稿',
    editHint: '草稿可修改招募信息；创建后起止时间已锁定。',
    editDraft: '编辑草稿',
    saveDraft: '保存草稿',
    saving: '保存中…',
    updateFailed: '无法更新组团',
    editOnlyDraftHint: '此组团已不是草稿，无法编辑。',
    backToDetail: '返回组团详情',
    cancelEdit: '取消',
    reloadAndRetry: '重新加载后再试',
    publicationIdLabel: '公开旅程',
    capacityLabel: '参加名额（主揪不占）',
    startAtLabel: '开始时间',
    dateConflict: {
      title: '日期与你已确认的组团重叠',
      body: '你在这段期间已确认加入或主办其他组团，因此无法加入这个组团。若要改参加这团，请先按原组团的规则退出。',
      openBody: '这段期间你已确认加入或主办其他组团，日期重叠，因此无法开放招募。',
      viewTrip: '查看原行程',
      tripListLabel: '日期重叠的组团',
      busy: '目前有其他加入申请正在处理，请稍后再试一次。',
      pendingTitle: '申请已送出',
      pendingBody: '提醒：你另有待审核的组团申请与此团日期重叠。若其中一团先被核准，另一团将无法加入。',
      applicantConflict: '这位申请人在此期间已确认加入其他组团，日期重叠，因此无法核准。',
    },
    endAtLabel: '结束时间',
    visibilityLabel: '可见性',
    discovery: {
      filtersLabel: '找组团',
      filtersDescription: '依关键字、出发日期与名额筛选公开组团。',
      keywordLabel: '关键字',
      keywordPlaceholder: '搜索标题或摘要',
      searchSubmit: '搜索',
      startFromLabel: '出发时间（起）',
      startToLabel: '出发时间（迄）',
      startFromHint: '日期是组团出发时间。',
      availableSlotsOnly: '只看尚有名额',
      sortLabel: '排序',
      sortLatest: '最新发布',
      sortStartAtAsc: '最近出发',
      clearFilters: '清除筛选',
      loadingMore: '加载更多中…',
      filterRefreshing: '更新结果中…',
      noFilterResults: '没有符合条件的组团',
      noFilterResultsHint: '试着调整关键字、出发时间或名额条件。',
      invalidDateRange: '出发时间（起）必须早于或等于出发时间（迄）。',
      departureAt: '出发：{time}',
    },
  },
  grouptrip: {
    validation: { failed: '请求参数不正确。' },
    not: { found: '找不到这笔组团。' },
    application: { not: { found: '找不到这笔申请。' } },
    participant: { not: { found: '找不到这笔 Participant。' } },
    permission: { denied: '没有权限执行此操作。' },
    capacity: { exceeded: '名额已满。' },
    invalid: { lifecycle: '目前状态无法执行此操作。' },
    concurrent: { modification: '数据已被其他人更新，请刷新后再试。' },
    date: {
      conflict: '你在这段期间已确认加入其他组团，日期重叠，无法加入。',
      conflict_other: '这位申请人在此期间已确认加入其他组团，日期重叠，因此无法核准。',
      check_busy: '目前有其他加入申请正在处理，请稍后再试一次。',
    },
    dates: { locked: '这趟旅程已绑定组团，起止日期、天数与每日日期已锁定；活动内容与时间仍可调整。' },
    conversation: {
      not: { found: '组团群聊尚未建立。' },
      permission: { denied: '只有主揪或已加入的旅伴可开启组团群聊。' },
    },
  },
  trade: {
    validation: { failed: '交易请求参数不正确。' },
    not: { found: '找不到这笔交易。' },
    permission: { denied: '没有权限执行此交易操作。' },
    payment: {
      failed: '钱包余额不足，请稍后再试。',
      platform_fee_destination_unavailable: '平台手续费账户尚未就绪，暂无法完成付款。',
    },
    conflict: '目前无法建立或取消交易。',
    buyer_cancel: {
      not_allowed: '目前无法取消此已付款交易。',
      after_start: '行程已开始或已过出发时间，无法自行取消并退款。',
      after_release: '款项已进入拨付流程，无法取消并退款。',
    },
  },
  vip: {
    quota: { exceeded: '您同时进行中的 Host 组团已达上限（上限 {0}，目前已 {1}）。' },
    member: { identity: { unavailable: '暂时无法读取会员 VIP 身份，请稍后再试。' } },
    fee: {
      configuration: { invalid: 'VIP 手续费设置无效，请联系管理员。' },
      disclosureTitle: '平台服务费（当前生效）',
      platformFeeRate: '平台服务费率：{rate}',
      platformFeeRateVip: '平台服务费率：{rate}（VIP）',
      includedInDisplayPrice: '平台服务费已含于参加者显示价格内；参加者不会另付「显示价＋服务费」。',
      hostReceivableHint: '每笔付费参加的主揪实收约为显示价格扣除平台服务费后的金额。',
      freeTripNoFee: '免费组团不收取平台服务费。',
      disclosureLoadFailed: '无法载入平台服务费说明。',
    },
  },
  review: {
    sectionTitle: '旅伴评价',
    ratingLabel: '评分',
    contentPlaceholder: '分享您的旅行体验（选填）',
    submitReview: '提交评价',
    submitting: '提交中…',
    deleteReview: '删除评价',
    confirmDelete: '确定要删除这条评价吗？',
    noReviews: '目前尚无评价。',
    loadMore: '加载更多评价',
    averageRating: '平均 {rating} 星',
    reviewCount: '{count} 条评价',
    noRatingYet: '暂无评价',
    hostReputationLabel: '主揪评价',
    eligibleHint: '行程已结束，您可以留下评价。',
    audiencePublic: '这是公开揪团：您的评价（评分、内容与您的公开显示名称）会公开显示，任何人都看得到。评分也会计入主揪的公开平均评分。',
    audienceFollowers: '这个揪团仅限主揪的关注者观看：您的评价（评分、内容与您的公开显示名称）会依此揪团的关注者范围显示，只有主揪、旅伴与主揪的关注者看得到。评分也会计入主揪的公开平均评分。',
    audiencePrivate: '这是私人揪团：您的评价（评分、内容与您的公开显示名称）只有这个揪团的主揪与旅伴看得到。评分也会计入主揪的公开平均评分。',
    listUnavailable: '目前无法查看这个揪团的评价。',
    alreadyReviewed: '您已留下评价。',
    notEligible: '您目前无法评价此组团。',
    loadFailed: '无法加载评价',
    submitFailed: '无法提交评价',
    deleteFailed: '无法删除评价',
    eligibilityLoadFailed: '无法读取评价资格',
    stars: (n) => '★'.repeat(n) + '☆'.repeat(5 - n),
    already_exists: '您已提交过评价。',
    deleted: '您之前提交的评价已被删除，无法再次提交。',
    not_eligible: '您目前没有评价资格。',
    not_found: '找不到这条评价。',
    permission: { denied: '没有权限删除此评价。' },
    validation: { failed: '评价请求参数不正确。' },
    concurrent: { modification: '数据已被更新，请重试。' },
  },
  commerce: {
    currency: {
      unsupported: '此币别目前不支持付费揪团',
    },
    earnings: {
      title: '收益与交易',
      subtitle: '依历史成交快照显示，不含提领或结算。',
      gross: '交易总额',
      grossHint: '含已退款成交量，不是已实现收入。',
      platform_fee: '平台服务费',
      host_receivable: '主揪应收',
      pending_release: '待拨付',
      released: '已拨付',
      refunded: '已退款',
    },
    history: {
      title: '交易记录',
      empty: '目前没有符合条件的交易。',
      loadFailed: '无法加载收益与交易',
      filterGroupTrip: '组团',
      filterGroupTripAll: '全部组团',
      filterStatus: '状态',
      filterStatusAll: '全部状态',
      buyer: '买家',
      buyerFallback: '旅伴',
      gross: '交易金额',
      platform_fee: '平台服务费',
      host_receivable: '主揪应收',
      paidAt: '付款时间',
      releasedAt: '拨付时间',
      refundedAt: '退款时间',
      createdAt: '创建时间',
      status: {
        AWAITING_PAYMENT: '待付款',
        PAID_PENDING_RELEASE: '待拨付',
        RELEASED: '已拨付',
        REFUNDED: '已退款',
        CANCELLED: '已取消',
      },
    },
  },
  safety: {
    report: '举报',
    block: '封锁',
    reportHost: '举报主揪',
    blockHost: '封锁主揪',
    reportParticipant: '举报旅伴',
    blockParticipant: '封锁旅伴',
    reportMember: '举报会员',
    reportPost: '举报贴文',
    reportContent: '举报内容',
    reportGroupTrip: '举报此组团',
    reason: '举报原因',
    optionalNote: '补充说明（选填）',
    submitReport: '提交举报',
    submitting: '提交中…',
    cancel: '取消',
    close: '关闭',
    reportSubmitted: '已提交举报，我们会进行审核。',
    reportFailed: '无法提交举报',
    blockConfirm: '确定要封锁此会员？封锁后仍不会自动取消组团或退款。',
    confirmBlock: '确认封锁',
    blocking: '封锁中…',
    memberBlocked: '已封锁',
    blockFailed: '无法封锁',
    actionFailed: '安全操作失败',
    authRequired: '请先登录后再进行举报或封锁。',
    reasons: {
      SPAM: '垃圾信息',
      HARASSMENT: '骚扰',
      HATE_OR_ABUSE: '仇恨或辱骂',
      SEXUAL_CONTENT: '不当性内容',
      VIOLENCE: '暴力',
      SCAM_OR_FRAUD: '诈骗或欺诈',
      IMPERSONATION: '冒充身份',
      PRIVACY: '隐私侵害',
      MISINFORMATION: '不实信息',
      OTHER: '其他',
    },
  },
  social: {
    safety: {
      block: {
        self: { not: { allowed: '不可封锁自己' } },
        relationship: { conflict: '封锁状态冲突，请重试' },
      },
      report: {
        self: { not: { allowed: '不可举报自己' } },
        target: { not: { found: '找不到举报对象' } },
        invalid: { reason: '举报原因无效' },
        idempotency: { conflict: '举报请求冲突，请重试' },
      },
      validation: { failed: '安全请求参数不正确' },
    },
  },
};
